// Copyright © 2025 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { getI18nFormattedMessage } from '../utils/intl';
import getI18nMessageFromGlobalStore from '../utils/globalMessageStore';

/** Common */
export const DOC_BASE_URL = 'https://techdocs.broadcom.com/us/en/ca-enterprise-software/layer7-api-management/api-developer-portal/5-3/';
export const KEY_ENTER = 'Enter';
export const ANY = 'any';
export const ALL = 'all';
export const KEYS = 'keys';
export const APIS = 'apis';
export const ORGANIZATION = 'ORGANIZATION';
export const DATE_FORMAT = 'MM/dd/yyyy';
export const SERVER_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXX"
export const AUDIT_LOGS_SERVER_DATE_FORMAT = 'ddd MMM DD YYYY HH:mm:ss ZZ'
export const IS_LESS_THAN = 'is less than';
export const IS_GREATER_THAN = 'is greater than';
export const EXPIRY_TYPE_CERTIFICATE = "CERTIFICATE";
export const EXPIRY_TYPE_SECRET = "SECRET";

export const LIST_SORT_BY = [
  {
    uuid: 'name,ASC',
    text: getI18nFormattedMessage('label.sort.by.name.asc'),
  }, {
    uuid: 'name,DESC',
    text: getI18nFormattedMessage('label.sort.by.name.desc'),
  }, {
    uuid: 'modifyTs,ASC',
    text: getI18nFormattedMessage('label.sort.by.updated.asc'),
  }, {
    uuid: 'modifyTs,DESC',
    text: getI18nFormattedMessage('label.sort.by.updated.desc'),
  }, {
    uuid: 'createTs,ASC',
    text: getI18nFormattedMessage('label.sort.by.created.asc'),
  }, {
    uuid: 'createTs,DESC',
    text: getI18nFormattedMessage('label.sort.by.created.desc'),
  },
];

export const AUDIT_LOGS_SORT_BY_ASCENDING = 'actionTs,ASC';
export const AUDIT_LOGS_SORT_BY_DESCENDING = 'actionTs,DESC';

export const APP_RESET = 'APP_RESET';
export const APP_LOADING = 'APP_LOADING';

export const PORTAL_STATUS_NEW = 'NEW';
export const PORTAL_STATUS_ENABLED = 'ENABLED';

export const API_ACCESS_STATUS_PRIVATE = 'PRIVATE';

export const USER_CONTEXTS_UPDATE_SUCCESS = 'API_PERMISSION_SAVE_USER_CONTEXTS_SUCCESS';

export const FETCH_REQUESTS_SUCCESS = 'FETCH_REQUESTS_SUCCESS';
export const FETCH_REQUESTS_ERROR = 'FETCH_REQUESTS_ERROR';

export const FETCH_APP_SECRET_HASHING_METADATA_SUCCESS = 'FETCH_APP_SECRET_HASHING_METADATA_SUCCESS';
export const FETCH_APP_SECRET_HASHING_METADATA_ERROR = 'FETCH_APP_SECRET_HASHING_METADATA_ERROR';
export const FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS = 'FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS';
export const FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR = 'FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR';

export const FETCH_APPLICATION_REQUEST_SETTING_SUCCESS = 'FETCH_APPLICATION_REQUEST_SETTING_SUCCESS';
export const FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS = 'FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS';
export const FETCH_APPLICATION_DELETE_REQUEST_SETTING_SUCCESS = 'FETCH_APPLICATION_DELETE_REQUEST_SETTING_SUCCESS';

export const FETCH_SETTING_USER_LOCK_CREATION_SUCCESS = 'FETCH_SETTING_USER_LOCK_CREATION_SUCCESS';

export const API_SUCCESS = 'API_SUCCESS';
export const API_ERROR = 'API_ERROR';
export const API_ERROR_CLOSE = 'API_ERROR_CLOSE';

export const API_DELETE_SUCCESS = 'API_DELETE_SUCCESS';
export const API_DELETE_ERROR = 'API_DELETE_ERROR';
export const API_DELETE_RESET = 'API_DELETE_RESET';

export const API_PERMISSION_AVAILABLE_USER_SUCCESS = 'API_PERMISSION_AVAILABLE_USER_SUCCESS';
export const API_PERMISSION_SAVE_SUCCESS = 'API_PERMISSION_SAVE_SUCCESS';
export const API_PERMISSION_SELECTED_USER_SUCCESS = 'API_PERMISSION_SELECTED_USER_SUCCESS';

export const API_LIST_REQUEST = 'API_LIST_REQUEST';
export const API_LIST_SUCCESS = 'API_LIST_SUCCESS';
export const API_LIST_ERROR = 'API_LIST_ERROR';
export const API_LIST_APPLICATIONS_SUCCESS = 'API_LIST_APPLICATIONS_SUCCESS';

export const API_LIST_ANALYTICS_LATENCY_REQUEST = 'API_LIST_ANALYTICS_LATENCY_REQUEST';
export const API_LIST_ANALYTICS_LATENCY_SUCCESS = 'API_LIST_ANALYTICS_LATENCY_SUCCESS';
export const API_LIST_ANALYTICS_LATENCY_ERROR = 'API_LIST_ANALYTICS_LATENCY_ERROR';

export const API_RECENT_SEARCH_SUCCESS = 'API_RECENT_SEARCH_SUCCESS';
export const API_RECENT_SEARCH_ERROR = 'API_RECENT_SEARCH_ERROR';
export const API_AUTO_SUGGESTION_SUCCESS = 'API_AUTO_SUGGESTION_SUCCESS';
export const API_AUTO_SUGGESTION_ERROR = 'API_AUTO_SUGGESTION_ERROR';

export const API_PERMISSION_ORGANIZATIONS_FILTERED_SUCCESS = 'API_PERMISSION_ORGANIZATIONS_FILTERED_SUCCESS';
export const API_PERMISSION_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_ORGANIZATIONS_SUCCESS';
export const API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS';
export const API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS';
export const API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS = 'API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS';
export const API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS = 'API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS';
export const API_PERMISSION_REDIRECT_API_TAB = 'API_PERMISSION_REDIRECT_API_TAB';

export const API_PERMISSION_ACCESS_STATUS_SUCCESS = 'API_PERMISSION_ACCESS_STATUS_SUCCESS';
export const API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS = 'API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS';
export const API_PERMISSION_PERMITTED_SUCCESS = 'API_PERMISSION_PERMITTED_SUCCESS';
export const API_PERMISSION_PERMITTED_ERROR = 'API_PERMISSION_PERMITTED_ERROR';

export const API_ORGANIZATION_ACCESS_SUCCESS = 'API_ORGANIZATION_ACCESS_SUCCESS';
export const API_ORG_ACCESS_BUTTONS_ADD_SUCCESS = 'API_ORG_ACCESS_BUTTONS_ADD_SUCCESS';
export const API_ORG_ACCESS_BUTTONS_REMOVE_SUCCESS = 'API_ORG_ACCESS_BUTTONS_REMOVE_SUCCESS';
export const API_ORGANIZATION_ACCESS_PATCH_REQUEST = 'API_ORGANIZATION_ACCESS_PATCH_REQUEST';
export const API_ORGANIZATION_ACCESS_PATCH_SUCCESS = 'API_ORGANIZATION_ACCESS_PATCH_SUCCESS';
export const API_ORGANIZATION_ACCESS_PATCH_ERROR = 'API_ORGANIZATION_ACCESS_PATCH_ERROR';

export const APIS_PRODUCTS_GET_SUCCESS = 'APIS_PRODUCTS_GET_SUCCESS';
export const APIS_PRODUCTS_UPDATE_ACCESS_REQUEST = 'APIS_PRODUCTS_UPDATE_ACCESS_REQUEST';
export const APIS_PRODUCTS_UPDATE_ACCESS_SUCCESS = 'APIS_PRODUCTS_UPDATE_ACCESS_SUCCESS';
export const APIS_PRODUCTS_ACCESS_STATUS_PRIVATE = 'PRIVATE'
export const APIS_PRODUCTS_ACCESS_STATUS_PUBLIC = 'PUBLIC'

export const API_TAGS_ALL_TAGS_REQUEST = 'API_TAGS_ALL_TAGS_REQUEST';
export const API_TAGS_ALL_TAGS_SUCCESS = 'API_TAGS_ALL_TAGS_SUCCESS';
export const API_TAGS_API_TAGS_REQUEST = 'API_TAGS_API_TAGS_REQUEST';
export const API_TAGS_API_TAGS_SUCCESS = 'API_TAGS_API_TAGS_SUCCESS';
export const API_SWAGGER_SUCCESS = 'API_SWAGGER_SUCCESS';
export const API_TAGS_CREATE_TAGS_SUCCESS = 'API_TAGS_CREATE_TAGS_SUCCESS';
export const API_TAGS_ASSOCIATE_REQUEST = 'API_TAGS_ASSOCIATE_REQUEST';
export const API_TAGS_ASSOCIATE_SUCCESS = 'API_TAGS_ASSOCIATE_SUCCESS';

export const API_USER_CONTEXTS = 'API_USER_CONTEXTS';

export const ACCESS_TYPE_GRANTED = 'GRANTED_DIRECT';
export const ACCESS_TYPE_MANAGED = 'MANAGED';
export const ACCESS_TYPE_NONE = 'NONE';

export const API_DETAILS_GET_PROXY_LIST_SUCCESS = 'API_DETAILSPROXY_LIST_SUCCESS';
export const API_DETAILS_GET_PROXY_LIST_ERROR = 'API_DETAILS_GET_PROXY_LIST_ERROR';
export const API_DETAILS_DEPLOY_PROXY_SUCCESS = 'API_DETAILS_DEPLOY_PROXY_SUCCESS';
export const API_DETAILS_REDEPLOY_PROXY_SUCCESS = 'API_DETAILS_REDEPLOY_PROXY_SUCCESS';
export const API_DETAILS_UNDEPLOY_PROXY_SUCCESS = 'API_DETAILS_UNDEPLOY_PROXY_SUCCESS';
export const API_DETAILS_DEPLOY_PROXY_ERROR = 'API_DETAILS_DEPLOY_PROXY_ERROR';
export const API_DETAILS_UNDEPLOY_PROXY_ERROR = 'API_DETAILS_UNDEPLOY_PROXY_ERROR';
export const API_DETAILS_REDEPLOY_PROXY_ERROR = 'API_DETAILS_REDEPLOY_PROXY_ERROR';
export const API_DETAILS_GET_DEPLOYMENT_LIST_SUCCESS = 'API_DETAILS_GET_DEPLOYMENT_LIST_SUCCESS';
export const API_DETAILS_GET_DEPLOYMENT_LIST_ERROR = 'API_DETAILS_GET_DEPLOYMENT_LIST_ERROR';

export const API_LOCATION_LIST_SUCCESS = 'API_LOCATION_LIST_SUCCESS';
export const API_LOCATION_LIST_ERROR = 'API_LOCATION_LIST_ERROR';
export const API_LOCATION_UPDATE_SUCCESS = 'API_LOCATION_UPDATE_SUCCESS';
export const API_LOCATION_UPDATE_ERROR = 'API_LOCATION_UPDATE_ERROR';
export const API_LOCATION_DELETE_SUCCESS = 'API_LOCATION_DELETE_SUCCESS';
export const API_LOCATION_DELETE_ERROR = 'API_LOCATION_DELETE_ERROR';

export const CHANGE = 'CHANGE';
export const API_PROXY_LIST_DELETE_REQUEST = 'API_PROXY_LIST_DELETE_REQUEST';
export const API_PROXY_LIST_DELETE_ERROR = 'API_PROXY_LIST_DELETE_ERROR';
export const API_PROXY_LIST_DELETE_SUCCESS = 'API_PROXY_LIST_DELETE_SUCCESS';
export const API_PROXY_LIST_ERROR = 'API_PROXY_LIST_ERROR';
export const API_PROXY_LIST_SUCCESS = 'API_PROXY_LIST_SUCCESS';
export const API_PROXY_LOADING = 'API_PROXY_LOADING';
export const API_PROXY_RESET = 'API_PROXY_RESET';
export const API_PROXY_VALIDATE_UNIQUE_NAME_RESET = 'API_PROXY_VALIDATE_UNIQUE_NAME_RESET';
export const API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS = 'API_PROXY_VALIDATE_UNIQUE_NAME_SUCCESS';
export const API_PROXY_VALIDATE_UNIQUE_NAME_ERROR = 'API_PROXY_VALIDATE_UNIQUE_NAME_ERROR';
export const API_PROXY_SAVE_STATUS_RESET = 'API_PROXY_SAVE_STATUS_RESET';
export const API_PROXY_CREATE_SUCCESS = 'API_PROXY_CREATE_SUCCESS';
export const API_PROXY_CREATE_ERROR = 'API_PROXY_CREATE_ERROR';
export const API_PROXY_UPDATE_SUCCESS = 'API_PROXY_UPDATE_SUCCESS';
export const API_PROXY_UPDATE_ERROR = 'API_PROXY_UPDATE_ERROR';
export const API_PROXY_DELETE_SUCCESS = 'API_PROXY_DELETE_SUCCESS';
export const API_PROXY_DELETE_ERROR = 'API_PROXY_DELETE_ERROR';
export const API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS = 'API_PROXY_FETCH_DEPLOYMENT_TYPE_SUCCESS';
export const API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR = 'API_PROXY_FETCH_DEPLOYMENT_TYPE_ERROR';
export const API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS = 'API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_SUCCESS';
export const API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR = 'API_PROXY_UPDATE_KEY_DEPLOYMENT_TYPE_ERROR';
export const API_PROXY_FETCH_ORGANIZATIONS_SUCCESS = 'API_PROXY_FETCH_ORGANIZATIONS_SUCCESS';
export const API_PROXY_FETCH_ORGANIZATIONS_ERROR = 'API_PROXY_FETCH_ORGANIZATIONS_ERROR';
export const API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS = 'API_PROXY_FETCH_SELECTED_ORGANIZATIONS_SUCCESS';
export const API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR = 'API_PROXY_FETCH_SELECTED_ORGANIZATIONS_ERROR';
export const API_PROXY_UPDATE_ORGS_SUCCESS = 'API_PROXY_UPDATE_ORGS_SUCCESS';
export const API_PROXY_UPDATE_ORGS_ERROR = 'API_PROXY_UPDATE_ORGS_ERROR';
export const API_PROXY_FETCH_DETAILS_SUCCESS = 'API_PROXY_FETCH_DETAILS_SUCCESS';
export const API_PROXY_FETCH_DETAILS_ERROR = 'API_PROXY_FETCH_DETAILS_ERROR';
export const FETCH_API_SYNC_FEATURE_FLAG_SUCCESS = 'FETCH_API_SYNC_FEATURE_FLAG_SUCCESS';
export const FETCH_API_SYNC_FEATURE_FLAG_ERROR = 'FETCH_API_SYNC_FEATURE_FLAG_ERROR';
export const FETCH_API_SYNC_COUNT_SUCCESS = 'FETCH_API_SYNC_COUNT_SUCCESS';
export const FETCH_API_SYNC_COUNT_ERROR = 'FETCH_API_SYNC_COUNT_ERROR';

export const FETCH_ACCOUNT_PLANS_ERROR = 'FETCH_ACCOUNT_PLANS_ERROR';
export const FETCH_API_PLANS_SUCCESS = 'FETCH_API_PLANS_SUCCESS';
export const FETCH_API_PLANS_ERROR = 'FETCH_API_PLANS_ERROR';
export const FETCH_API_PLAN_SUCCESS = 'FETCH_API_PLAN_SUCCESS';
export const FETCH_API_GROUP_SUCCESS = 'FETCH_API_GROUP_SUCCESS';
export const NONE = '';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';
export const RESET = 'RESET';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAIL = 'CREATE_FAIL';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_FAIL';
export const ALERT_SUCCESS = 'success';
export const ALERT_ERROR = 'error';
export const INFO = 'info';
export const NONE_TEXT = 'None';
export const ASSIGNED = 'ASSIGNED';
export const NOT_ASSIGNED = 'NOT_ASSIGNED';

export const PENDING_DEPLOYMENT = 'PENDING_DEPLOYMENT';

export const API_OWNER_TEXT = 'API Owner';
export const DEVELOPER_TEXT = 'Organization Admin';
export const ORGANIZATION_ADMIN_TEXT = 'Developer';

export const CUSTOM_FIELDS_GET_SUCCESS = 'CUSTOM_FIELDS_GET_SUCCESS';
export const POLICY_TEMPLATES_GET_SUCCESS = 'POLICY_TEMPLATES_GET_SUCCESS';

export const API_EULAS_SUCCESS = 'API_EULAS_SUCCESS';
export const APPLICATION_API_GROUP_EULAS_GET_SUCCESS = 'APPLICATION_API_GROUP_EULAS_GET_SUCCESS';
export const API_NAME_UNIQUE_SUCCESS = 'API_NAME_UNIQUE_SUCCESS';
export const API_PROXY_URL_UNIQUE_SUCCESS = 'API_PROXY_URL_UNIQUE_SUCCESS';
export const API_GET_SUCCESS = 'API_GET_SUCCESS';
export const API_SAVE_SUCCESS = 'API_SAVE_SUCCESS';
export const API_UPDATE_SUCCESS = 'API_UPDATE_SUCCESS';
export const API_PUBLISH_SAVE_SUCCESS = 'API_PUBLISH_SAVE_SUCCESS';
export const API_ASSETS_GET_SUCCESS = 'API_ASSETS_GET_SUCCESS';
export const API_USAGE_GET_SUCCESS = 'API_USAGE_GET_SUCCESS';
export const API_CUSTOM_FIELDS_GET_SUCCESS = 'API_CUSTOM_FIELDS_GET_SUCCESS';
export const API_CUSTOM_FIELDS_SAVE_SUCCESS = 'API_CUSTOM_FIELDS_SAVE_SUCCESS';
export const API_POLICY_TEMPLATES_GET_SUCCESS = 'API_POLICY_TEMPLATES_GET_SUCCESS';
export const API_POLICY_TEMPLATES_SAVE_SUCCESS = 'API_POLICY_TEMPLATES_SAVE_SUCCESS';

export const APPLICATION_LOADING = 'APPLICATION_LOADING';
export const APPLICATION_ERROR = 'APPLICATION_ERROR';

export const APPLICATION_GRANULAR_CREATE_REQUEST = 'APPLICATION_GRANULAR_CREATE_REQUEST';
export const APPLICATION_GRANULAR_CREATE_SUCCESS = 'APPLICATION_GRANULAR_CREATE_SUCCESS';
export const APPLICATION_GRANULAR_CREATE_ERROR = 'APPLICATION_GRANULAR_CREATE_ERROR';
export const APPLICATION_PUBLISH_REQUEST = 'APPLICATION_PUBLISH_REQUEST';
export const APPLICATION_PUBLISH_ERROR = 'APPLICATION_PUBLISH_ERROR'
export const APPLICATION_PUBLISH_SUCCESS = 'APPLICATION_PUBLISH_SUCCESS';
export const APPLICATION_ASSIGNED_APIS_GET_SUCCESS = 'APPLICATION_ASSIGNED_APIS_GET_SUCCESS';
export const APPLICATION_ASSIGNED_APIS_GET_ERROR = 'APPLICATION_ASSIGNED_APIS_GET_ERROR';
export const APPLICATION_ASSIGNED_APIS_UPDATE_REQUEST = 'APPLICATION_ASSIGNED_APIS_UPDATE_REQUEST';
export const APPLICATION_ASSIGNED_APIS_UPDATE_SUCCESS = 'APPLICATION_ASSIGNED_APIS_UPDATE_SUCCESS';
export const APPLICATION_ASSIGNED_APIS_UPDATE_ERROR = 'APPLICATION_ASSIGNED_APIS_UPDATE_ERROR';

export const APPLICATION_ASSIGNED_API_PLANS_GET_SUCCESS = 'APPLICATION_ASSIGNED_API_PLANS_GET_SUCCESS';
export const APPLICATION_ASSIGNED_API_PLANS_GET_ERROR = 'APPLICATION_ASSIGNED_API_PLANS_GET_ERROR';
export const APPLICATION_ASSIGNED_API_PLANS_UPDATE_REQUEST = 'APPLICATION_ASSIGNED_API_PLANS_UPDATE_REQUEST';
export const APPLICATION_ASSIGNED_API_PLANS_UPDATE_SUCCESS = 'APPLICATION_ASSIGNED_API_PLANS_UPDATE_SUCCESS';
export const APPLICATION_ASSIGNED_API_PLANS_UPDATE_ERROR = 'APPLICATION_ASSIGNED_API_PLANS_UPDATE_ERROR';

export const APPLICATION_API_PRODUCTS_ACCESS_UPDATE_REQUEST = 'APPLICATION_API_PRODUCTS_ACCESS_UPDATE_REQUEST';
export const APPLICATION_API_PRODUCTS_ACCESS_UPDATE_SUCCESS = 'APPLICATION_API_PRODUCTS_ACCESS_UPDATE_SUCCESS';
export const APPLICATION_API_PRODUCTS_ACCESS_UPDATE_ERROR = 'APPLICATION_API_PRODUCTS_ACCESS_UPDATE_ERROR';
export const APPLICATION_API_PRODUCTS_ACCESS_UPDATE_RESET = "APPLICATION_API_PRODUCTS_ACCESS_UPDATE_RESET"

export const APPLICATION_GET_REQUEST_STATUS_REQUEST = 'APPLICATION_GET_REQUEST_STATUS_REQUEST';
export const APPLICATION_GET_REQUEST_STATUS_SUCCESS = 'APPLICATION_GET_REQUEST_STATUS_SUCCESS';
export const APPLICATION_GET_REQUEST_STATUS_ERROR = 'APPLICATION_GET_REQUEST_STATUS_ERROR';

export const APPLICATION_ASSIGNED_API_GROUPS_GET_SUCCESS = 'APPLICATION_ASSIGNED_API_GROUPS_GET_SUCCESS';
export const APPLICATION_ASSIGNED_API_GROUPS_GET_ERROR = 'APPLICATION_ASSIGNED_API_GROUPS_GET_ERROR';
export const APPLICATION_ASSIGNED_API_GROUPS_UPDATE_REQUEST = 'APPLICATION_ASSIGNED_API_GROUPS_UPDATE_REQUEST';
export const APPLICATION_ASSIGNED_API_GROUPS_UPDATE_SUCCESS = 'APPLICATION_ASSIGNED_API_GROUPS_UPDATE_SUCCESS';
export const APPLICATION_ASSIGNED_API_GROUPS_UPDATE_ERROR = 'APPLICATION_ASSIGNED_API_GROUPS_UPDATE_ERROR';

export const APPLICATION_GRANULAR_UPDATE_REQUEST = 'APPLICATION_GRANULAR_UPDATE_REQUEST';
export const APPLICATION_GRANULAR_UPDATE_SUCCESS = 'APPLICATION_GRANULAR_UPDATE_SUCCESS';
export const APPLICATION_GRANULAR_UPDATE_ERROR = 'APPLICATION_GRANULAR_UPDATE_ERROR';
export const APPLICATION_CUSTOM_FIELD_VALUES_GET_SUCCESS = 'APPLICATION_CUSTOM_FIELD_VALUES_GET_SUCCESS';
export const APPLICATION_CUSTOM_FIELD_VALUES_GET_ERROR = 'APPLICATION_CUSTOM_FIELD_VALUES_GET_ERROR';
export const APPLICATION_SECRET_UPDATE_SUCCESS = 'APPLICATION_SECRET_UPDATE_SUCCESS';
export const APPLICATION_NAME_UNIQUE_SUCCESS = 'APPLICATION_NAME_UNIQUE_SUCCESS';
export const APPLICATION_NAME_UNIQUE_REQUEST = 'APPLICATION_NAME_UNIQUE_REQUEST';
export const APPLICATION_NAME_UNIQUE_ERROR = 'APPLICATION_NAME_UNIQUE_ERROR';
export const APPLICATION_CUSTOM_FIELDS_UPDATE_REQUEST = 'APPLICATION_CUSTOM_FIELDS_UPDATE_REQUEST';
export const APPLICATION_CUSTOM_FIELDS_UPDATE_SUCCESS = 'APPLICATION_CUSTOM_FIELDS_UPDATE_SUCCESS';
export const APPLICATION_CUSTOM_FIELDS_UPDATE_ERROR = 'APPLICATION_CUSTOM_FIELDS_UPDATE_ERROR';
export const APPLICATION_ORGANIZATIONS_GET_SUCCESS = 'APPLICATION_ORGANIZATIONS_GET_SUCCESS';
export const APPLICATION_CUSTOM_FIELDS_GET_SUCCESS = 'APPLICATION_CUSTOM_FIELDS_GET_SUCCESS';
export const APPLICATION_AVAILABLE_APIS_GET_SUCCESS = 'APPLICATION_AVAILABLE_APIS_GET_SUCCESS';
export const APPLICATION_AVAILABLE_APPS_GET_SUCCESS = 'APPLICATION_AVAILABLE_APPS_GET_SUCCESS';
export const APPLICATION_AVAILABLE_ORGS_GET_SUCCESS = 'APPLICATION_AVAILABLE_ORGS_GET_SUCCESS';
export const APPLICATION_API_EULA_GET_SUCCESS = 'APPLICATION_API_EULA_GET_SUCCESS';
export const APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS = 'APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS';
export const APPLICATION_GENERATE_SECRET_GET_SUCCESS = 'APPLICATION_GENERATE_SECRET_GET_SUCCESS';
export const APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS = 'APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS';
export const APPLICATION_AVAILABLE_API_PRODUCTS_GET_REQUEST = 'APPLICATION_AVAILABLE_API_PRODUCTS_GET_REQUEST';
export const APPLICATION_AVAILABLE_API_PRODUCTS_GET_SUCCESS = 'APPLICATION_AVAILABLE_API_PRODUCTS_GET_SUCCESS';
export const APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS = 'APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS';

export const TENANT_INFO_GET_SUCCESS = 'TENANT_INFO_GET_SUCCESS';
export const APPLICATION_APP_KEY_SECRET_DEFAULT_HASH_FROM_DB = '********';
export const APPLICATION_ALL_APIS_GET_SUCCESS = 'APPLICATION_ALL_APIS_GET_SUCCESS';
export const APPLICATION_ALL_APPS_GET_SUCCESS = 'APPLICATION_ALL_APPS_GET_SUCCESS';

export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_ERROR = 'PRODUCT_LIST_ERROR';

export const PROXIES_GET_SUCCESS = 'PROXIES_GET_SUCCESS';
export const PROXIES_ERROR = 'PROXIES_ERROR';

export const API_KEY_STATUS_DISABLED = 'DISABLED';
export const API_KEY_STATUS_ENABLED = 'ENABLED';
export const API_KEY_STATUS_EXPIRED = 'EXPIRED';
export const API_KEY_STATUS_PENDING_REGISTRATION = 'PENDING_REGISTRATION';
export const API_KEY_STATUS_DELETE_FAILED = 'DELETE_FAILED';
export const API_KEY_PROXIES_GET_SUCCESS = 'API_KEY_PROXIES_GET_SUCCESS';
export const API_KEY_PROXIES_GET_ERROR = 'API_KEY_PROXIES_GET_ERROR';
export const API_KEY_DEPLOY_SUCCESS = 'API_KEY_DEPLOY_SUCCESS';
export const API_KEY_DEPLOY_ERROR = 'API_KEY_DEPLOY_ERROR';
export const API_KEY_REDEPLOY_SUCCESS = 'API_KEY_REDEPLOY_SUCCESS';
export const API_KEY_REDEPLOY_ERROR = 'API_KEY_REDEPLOY_ERROR';
export const API_KEY_UNDEPLOY_SUCCESS = 'API_KEY_UNDEPLOY_SUCCESS';
export const API_KEY_UNDEPLOY_ERROR = 'API_KEY_UNDEPLOY_ERROR';

export const APPLICATION_ALL_KEYS_GET_SUCCESS = 'APPLICATION_ALL_KEYS_GET_SUCCESS';
export const APPLICATION_ALL_KEYS_GET_ERROR = 'APPLICATION_ALL_KEYS_GET_ERROR';
export const APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS = 'APPLICATION_ALL_KEYS_COUNT_GET_SUCCESS';
export const APPLICATION_ALL_KEYS_COUNT_GET_ERROR = 'APPLICATION_ALL_KEYS_COUNT_GET_ERROR';
export const KEY_NAME_UNIQUE_SUCCESS = 'KEY_NAME_UNIQUE_SUCCESS';
export const KEY_NAME_UNIQUE_ERROR = 'KEY_NAME_UNIQUE_ERROR';
export const KEY_STATUS_RESET = 'KEY_STATUS_RESET';
export const KEY_DELETE_STATUS_RESET = 'KEY_DELETE_STATUS_RESET';

export const KEY_CREATE_SUCCESS = 'KEY_CREATE_SUCCESS';
export const KEY_CREATE_ERROR = 'KEY_CREATE_ERROR';
export const KEY_UPDATE_SUCCESS = 'KEY_UPDATE_SUCCESS';
export const KEY_UPDATE_ERROR = 'KEY_UPDATE_ERROR';
export const KEY_REGENERATE_SECRET_REQUEST = 'KEY_REGENERATE_SECRET_REQUEST';
export const KEY_REGENERATE_SECRET_SUCCESS = 'KEY_REGENERATE_SECRET_SUCCESS';
export const KEY_REGENERATE_SECRET_ERROR = 'KEY_REGENERATE_SECRET_ERROR';
export const KEY_DELETE_SUCCESS = 'KEY_DELETE_SUCCESS';
export const KEY_DELETE_ERROR = 'KEY_DELETE_ERROR';
export const KEY_STATUS_DELETE_FAILED = 'DELETE_FAILED';
export const APPLICATION_SINGLE_GET_SUCCESS = 'APPLICATION_SINGLE_GET_SUCCESS';
export const APPLICATION_SINGLE_GET_ERROR = 'APPLICATION_SINGLE_GET_ERROR';
export const APPLICATION_API_PLANS_GET_SUCCESS = 'APPLICATION_API_PLANS_GET_SUCCESS';
export const APPLICATION_DELETE_RESET = 'APPLICATION_DELETE_RESET';
export const APPLICATION_DELETE_SUCCESS = 'APPLICATION_DELETE_SUCCESS';
export const APPLICATION_DELETE_ERROR = 'APPLICATION_DELETE_ERROR';
export const APPLICATION_STATUS_UPDATE_RESET = 'APPLICATION_STATUS_UPDATE_RESET';
export const APPLICATION_STATUS_UPDATE_ERROR = 'APPLICATION_STATUS_UPDATE_ERROR';
export const APPLICATION_API_GET_LIST_SUCCESS = 'APPLICATION_API_GET_LIST_SUCCESS';
export const APPLICATION_API_GET_LIST_ERROR = 'APPLICATION_API_GET_LIST_ERROR';
export const APPLICATION_APIS_UPDATE_SUCCESS = 'APPLICATION_APIS_UPDATE_SUCCESS';
export const APPLICATION_APIS_UPDATE_ERROR = 'APPLICATION_APIS_UPDATE_ERROR';
export const APPLICATION_APIS_UPDATE_RESET = 'APPLICATION_APIS_UPDATE_RESET';
export const APPLICATION_PRODUCT_API_GET_LIST_SUCCESS = 'APPLICATION_PRODUCT_API_GET_LIST_SUCCESS';
export const APPLICATION_PRODUCT_API_GET_LIST_ERROR = 'APPLICATION_PRODUCT_API_GET_LIST_ERROR';
export const APPLICATION_PRODUCT_API_PATCH_SUCCESS = 'APPLICATION_PRODUCT_API_PATCH_SUCCESS';
export const APPLICATION_PRODUCT_API_PATCH_ERROR = 'APPLICATION_PRODUCT_API_PATCH_ERROR';
export const APPLICATION_PRODUCT_API_PATCH_RESET = 'APPLICATION_PRODUCT_API_PATCH_RESET';
export const APPLICATION_PRODUCT_TIERS_GET_SUCCESS = 'APPLICATION_PRODUCT_TIERS_GET_SUCCESS';
export const APP_KEY_STORES_GET_SUCCESS = 'APP_KEY_STORES_GET_SUCCESS';
export const APP_KEY_STORES_GET_ERROR = 'APP_KEY_STORES_GET_ERROR';
export const API_KEY_STORES_GET_SUCCESS = 'API_KEY_STORES_GET_SUCCESS';
export const API_KEY_STORES_GET_ERROR = 'API_KEY_STORES_GET_ERROR';
export const API_KEY_STORE_DEPLOY_SUCCESS = 'API_KEY_STORE_DEPLOY_SUCCESS';
export const API_KEY_STORE_DEPLOY_ERROR = 'API_KEY_STORE_DEPLOY_ERROR';
export const API_KEY_STORE_REDEPLOY_SUCCESS = 'API_KEY_STORE_REDEPLOY_SUCCESS';
export const API_KEY_STORE_REDEPLOY_ERROR = 'API_KEY_STORE_REDEPLOY_ERROR';
export const API_KEY_STORE_UNDEPLOY_SUCCESS = 'API_KEY_STORE_UNDEPLOY_SUCCESS';
export const API_KEY_STORE_UNDEPLOY_ERROR = 'API_KEY_STORE_UNDEPLOY_ERROR';

export const APPLICATION_CERTIFICATE_GET_LIST_SUCCESS = 'APPLICATION_CERTIFICATE_GET_LIST_SUCCESS';
export const APPLICATION_CERTIFICATE_GET_LIST_ERROR = 'APPLICATION_CERTIFICATE_GET_LIST_ERROR';
export const APPLICATION_CERTIFICATE_ADD_SUCCESS = 'APPLICATION_CERTIFICATE_ADD_SUCCESS';
export const APPLICATION_CERTIFICATE_ADD_ERROR = 'APPLICATION_CERTIFICATE_ADD_ERROR';
export const APPLICATION_CERTIFICATE_RESET = 'APPLICATION_CERTIFICATE_RESET';
export const APPLICATION_CERTIFICATE_DELETE_SUCCESS = 'APPLICATION_CERTIFICATE_DELETE_SUCCESS';
export const APPLICATION_CERTIFICATE_DELETE_ERROR = 'APPLICATION_CERTIFICATE_DELETE_ERROR';

export const TYPE_API = 'TYPE_API';
export const TYPE_API_GROUP = 'TYPE_API_GROUP';

export const API_STATUS_DISABLED = 'DISABLED';
export const API_STATUS_ENABLED = 'ENABLED';
export const API_STATUS_NEW = 'NEW';
export const API_STATUS_DEPRECATED = 'DEPRECATED';
export const API_STATUS_INCOMPLETE = 'INCOMPLETE';
export const API_STATUS_PENDING_BUNDLE = 'PENDING_BUNDLE';

export const APPLICATION_STATUS_ENABLED = 'ENABLED';
export const APPLICATION_STATUS_DISABLED = 'DISABLED';
export const APPLICATION_STATUS_INCOMPLETE = 'INCOMPLETE';
export const APPLICATION_STATUS_PENDING_APPROVAL = 'APPLICATION_PENDING_APPROVAL';
export const APPLICATION_STATUS_EDIT_PENDING_APPROVAL = 'EDIT_APPLICATION_PENDING_APPROVAL';
export const APPLICATION_STATUS_REJECTED = 'REJECTED';
export const APPLICATION_STATUS_DELETE_PENDING_APPROVAL = 'DELETE_APPLICATION_PENDING_APPROVAL';
export const APPLICATION_STATUS_DELETE_FAILED = 'DELETE_FAILED';

export const APPLICATION_DISABLED_BY_TYPE_EXTERNAL = 'EXTERNAL';

export const DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS = 'DASHBOARD_AUTOSUGGEST_SHOW_SUCCESS';
export const DASHBOARD_AUTOSUGGEST_SHOW_ERROR = 'DASHBOARD_AUTOSUGGEST_SHOW_ERROR';
export const DASHBOARD_GET_ENTITY_COUNT_SUCCESS = 'DASHBOARD_GET_ENTITY_COUNT_SUCCESS';
export const DASHBOARD_GET_ENTITY_COUNT_ERROR = 'DASHBOARD_GET_ENTITY_COUNT_ERROR';
export const DASHBOARD_CHART_DATA_SUCCESS = 'DASHBOARD_CHART_DATA_SUCCESS';
export const DASHBOARD_CHART_DATA_ERROR = 'DASHBOARD_CHART_DATA_ERROR';

export const DEPLOYMENT_STATUS_DEPLOYED = 'DEPLOYED';
export const DEPLOYMENT_STATUS_PENDING_DEPLOYMENT = 'PENDING_DEPLOYMENT';
export const DEPLOYMENT_STATUS_PENDING_UNDEPLOYMENT = 'PENDING_UNDEPLOYMENT';
export const DEPLOYMENT_STATUS_ERROR = 'ERROR';
export const DEPLOYMENT_STATUS_ERROR_UNDEPLOY = 'ERROR_UNDEPLOY';
export const DEPLOYMENT_STATUS_NOT_DEPLOYED = 'NOT_DEPLOYED';
export const DEPLOYMENT_ACTION_TYPE_DEPLOY = 'DEPLOY';
export const DEPLOYMENT_ACTION_TYPE_REDEPLOY = 'REDEPLOY';
export const DEPLOYMENT_ACTION_TYPE_UNDEPLOY = 'UNDEPLOY';
export const DEPLOYMENT_STATUS_UNDEPLOYED_ERROR = 'ERROR_UNDEPLOY';

export const FETCH_CUSTOM_PAGES_SUCCESS = 'FETCH_CUSTOM_PAGES_SUCCESS';
export const FETCH_CUSTOM_PAGES_ERROR = 'FETCH_CUSTOM_PAGES_ERROR';
export const FETCH_CUSTOM_PAGES_BUNDLES_SUCCESS = 'FETCH_CUSTOM_PAGES_BUNDLES_SUCCESS';
export const FETCH_CUSTOM_PAGES_BUNDLES_ERROR = 'FETCH_CUSTOM_PAGES_BUNDLES_ERROR';
export const FETCH_CUSTOM_PAGES_LIST_IN_BUNDLE_SUCCESS = 'FETCH_CUSTOM_PAGES_LIST_IN_BUNDLE_SUCCESS';
export const FETCH_CUSTOM_PAGES_LIST_IN_BUNDLE_ERROR = 'FETCH_CUSTOM_PAGES_LIST_IN_BUNDLE_ERROR';
export const UPLOAD_CUSTOM_PAGES_BUNDLE_SUCCESS = 'UPLOAD_CUSTOM_PAGES_BUNDLE_SUCCESS';
export const UPLOAD_CUSTOM_PAGES_BUNDLE_ERROR = 'UPLOAD_CUSTOM_PAGES_BUNDLE_ERROR';
export const DELETE_CUSTOM_PAGES_BUNDLE_SUCCESS = 'DELETE_CUSTOM_PAGES_BUNDLE_SUCCESS';
export const DELETE_CUSTOM_PAGES_BUNDLE_ERROR = 'DELETE_CUSTOM_PAGES_BUNDLE_ERROR';
export const SAVE_CUSTOM_PAGES_SUCCESS = 'SAVE_CUSTOM_PAGES_SUCCESS';
export const SAVE_CUSTOM_PAGES_ERROR = 'SAVE_CUSTOM_PAGES_ERROR';
export const SAVE_CUSTOM_PAGES_RESET_SUCCESS = 'SAVE_CUSTOM_PAGES_RESET_SUCCESS';
export const RESET_CUSTOM_PAGES_SUCCESS_MESSAGE = 'RESET_CUSTOM_PAGES_SUCCESS_MESSAGE';

/** APIs */
export const APIS_LIST_VISIBILITIES_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.apis.filter.visibilities.all'),
  }, {
    uuid: 'Public',
    text: getI18nFormattedMessage('label.apis.filter.visibilities.public'),
  }, {
    uuid: 'Private',
    text: getI18nFormattedMessage('label.apis.filter.visibilities.private'),
  },
];

export const API_EDIT_ACCESS_STATUS = [
  {
    uuid: 'PUBLIC',
    name: 'Public',
  }, {
    uuid: 'PRIVATE',
    name: 'Private',
  },
];

export const APIS_LIST_STATES_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.apis.filter.states.all'),
  }, {
    uuid: 'Enabled',
    text: getI18nFormattedMessage('label.apis.filter.states.enabled'),
  }, {
    uuid: 'Disabled',
    text: getI18nFormattedMessage('label.apis.filter.states.disabled'),
  }, {
    uuid: 'Deprecated',
    text: getI18nFormattedMessage('label.apis.filter.states.deprecated'),
  }, {
    uuid: 'New',
    text: getI18nFormattedMessage('label.apis.filter.states.unpublished'),
  }, {
    uuid: 'Incomplete',
    text: getI18nFormattedMessage('label.apis.filter.states.incomplete'),
  },
];

export const CATEGORY_APIS_LIST_STATUS_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.category.details.apis.filter.apistatus'),
  }, {
    uuid: 'ENABLED',
    text: getI18nFormattedMessage('label.apis.filter.states.enabled'),
  }, {
    uuid: 'DISABLED',
    text: getI18nFormattedMessage('label.apis.filter.states.disabled'),
  }, {
    uuid: 'DEPRECATED',
    text: getI18nFormattedMessage('label.apis.filter.states.deprecated'),
  }, {
    uuid: 'NEW',
    text: getI18nFormattedMessage('label.apis.filter.states.unpublished'),
  }, {
    uuid: 'INCOMPLETE',
    text: getI18nFormattedMessage('label.apis.filter.states.incomplete'),
  },
];

export const CATEGORY_APIS_LIST_APPLICABLE_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.category.details.apis.filter.applicable.all'),
  }, {
    uuid: 'APPLICABLE',
    text: getI18nFormattedMessage('label.category.details.apis.filter.applicable'),
  }, {
    uuid: 'NOT_APPLICABLE',
    text: getI18nFormattedMessage('label.category.details.apis.filter.notapplicable'),
  },
];

export const CATEGORY_APIS_LIST_COMPLIANCE_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.category.details.apis.filter.compliant.all'),
  }, {
    uuid: 'COMPLIANT',
    text: getI18nFormattedMessage('label.category.details.apis.filter.compliant'),
  }, {
    uuid: 'ERROR',
    text: getI18nFormattedMessage('label.category.details.apis.filter.notcompliant'),
  }, {
    uuid: 'NOT_APPLICABLE',
    text: getI18nFormattedMessage('label.category.details.apis.filter.notapplicable'),
  },
];

export const CATEGORY_APIS_LIST_ASSIGNED_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.category.details.apis.filter.assigned.all'),
  }, {
    uuid: 'ASSIGNED',
    text: getI18nFormattedMessage('label.category.details.apis.filter.assigned'),
  }, {
    uuid: 'NOT_ASSIGNED',
    text: getI18nFormattedMessage('label.category.details.apis.filter.notassigned'),
  },
];

export const APP_APIS_LIST_STATES_FILTER_OPTIONS = [
  {
    uuid: 'All',
    text: getI18nFormattedMessage('label.apis.filter.states.all'),
  }, {
    uuid: 'Enabled',
    text: getI18nFormattedMessage('label.apis.filter.states.enabled'),
  }, {
    uuid: 'Disabled',
    text: getI18nFormattedMessage('label.apis.filter.states.disabled'),
  }, {
    uuid: 'Deprecated',
    text: getI18nFormattedMessage('label.apis.filter.states.deprecated'),
  },
];

export const APIS_LIST_SORT_BY = [
  {
    uuid: 'name,ASC',
    text: getI18nFormattedMessage('label.apis.filter.sortby.name.asc'),
  }, {
    uuid: 'name,DESC',
    text: getI18nFormattedMessage('label.apis.filter.sortby.name.desc'),
  }, {
    uuid: 'createTs,DESC',
    text: getI18nFormattedMessage('label.apis.filter.sortby.date.created.desc'),
  }, {
    uuid: 'createTs,ASC',
    text: getI18nFormattedMessage('label.apis.filter.sortby.date.created.asc'),
  }, {
    uuid: 'modifyTs,DESC',
    text: getI18nFormattedMessage('label.apis.filter.sortby.date.modified.desc'),
  }, {
    uuid: 'modifyTs,ASC',
    text: getI18nFormattedMessage('label.apis.filter.sortby.date.modified.asc'),
  },
];

/* API LOCATION TAB */
export const ALL_LOCATION = 'All locations';
export const DEFAULT_LOCATION = 'Default Location'
export const NON_DEFAULT_LOCATION = 'Non-Default Location'
export const API_LOCATION_TYPE = [
  {
    uuid: ALL_LOCATION,
    text: getI18nFormattedMessage('label.api.location.tab.filter.location.all'),
  }, {
    uuid: DEFAULT_LOCATION,
    text: getI18nFormattedMessage('label.api.location.tab.filter.location.default'),
  }, {
    uuid: NON_DEFAULT_LOCATION,
    text: getI18nFormattedMessage('label.api.location.tab.filter.location.non.default'),
  },
];

/** Applications */
export const HELP_ITEMS = {
  details: {
    title: 'How do I Publish an Application?',
    descriptions: '',
    subItems: [
      {
        id: 0,
        title: '',
        descriptions: 'On the Details tab, select the organization (if you are a Global Publisher) and enter a name and description. Note: If you are an Org User, the org for the application will be the org that you belong to.',
      },
      {
        id: 1,
        title: '',
        descriptions: 'On the API Management tab, add APIs.',
      },
      {
        id: 2,
        title: '',
        descriptions: 'On the Authentication tab, if any of the added APIs use OAuth, specify the callback/redirect URL and scope. Set the type to public or confidential.',
      },
      {
        id: 3,
        title: '',
        descriptions: 'On the Key tab, you can view the API Key and Shared Secret and you can generate a new plain or hashed secret.',
      },
      {
        id: 4,
        title: '',
        descriptions: 'You can add multiple API keys to your application. First, add your application. This generates the default API key for the application. To add other API keys, edit your application.',
      },
    ],
  },
};

export const MULTIKEY_HELP_ITEMS = {
  details: {
    title: 'How do I publish an Application?',
    descriptions: '',
    subItems: [
      {
        id: 0,
        title: '',
        descriptions: 'On the Details tab, select the organization (if you are a Global Publisher) and enter a name and description. Note: If you are an Org User, the org for the application will be the org that you belong to.',
      },
      {
        id: 1,
        title: '',
        descriptions: 'On the API Management tab, add APIs.',
      },
      {
        id: 2,
        title: '',
        descriptions: 'On the Authentication & Keys tab, manage the API keys for the application. API Portal auto-generates an API key, a shared secret, and the other settings that you defined for the application when a user adds an application to API Portal. This is the default API key for the application. You can add more keys to the application.',
      },
    ],
  },
};

/** Gateway Bundles */

export const SYSTEM_BUNDLE_GROUP_NAME = 'l7.apim.system';

export const GATEWAY_BUNDLES_LIST_SORT_BY = [
  {
    uuid: 'createTs,DESC',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.sort.by.date.created.desc'),
  }, {
    uuid: 'createTs,ASC',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.sort.by.date.created.asc'),
  }, {
    uuid: 'name,ASC',
    text: getI18nFormattedMessage('label.sort.by.name.asc'),
  }, {
    uuid: 'name,DESC',
    text: getI18nFormattedMessage('label.sort.by.name.desc'),
  },
];

export const GATEWAY_BUNDLES_LIST_TYPE_BY = [
  {
    uuid: 'any',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.type.by.any.bundle.types'),
  }, {
    uuid: 'ALL',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.type.by.all.bundle.types'),
  },
  {
    uuid: 'ENCAPSULATED_ASSERTION',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.type.by.encapsulated.assertion'),
  }, {
    uuid: 'ENVIRONMENT',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.type.by.environment'),
  },
];

export const GRAPHMAN = 'Graphman';
export const POLICY_PLUGIN = 'Policy Plugin'

export const GATEWAY_BUNDLES_LIST_BUNDLE_FORMAT_BY = [
  {
    uuid: ALL,
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.bundle.format.by.all'),
  }, {
    uuid: POLICY_PLUGIN,
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.bundle.format.by.policy.plugin'),
  }, {
    uuid: GRAPHMAN,
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.bundle.format.by.graphman'),
  },
];

export const GATEWAY_BUNDLES_LIST_PORTAL_TEMPLATE_BY = [
  {
    uuid: 'any',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.policy.template.by.any'),
  }, {
    uuid: 'true',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.policy.template.by.true'),
  }, {
    uuid: 'false',
    text: getI18nFormattedMessage('label.gateway.bundle.list.page.policy.template.by.false'),
  },
];

export const GATEWAY_BUNDLES_API_SORT_BY = [
  {
    uuid: 'apiModifyTs,DESC',
    text: getI18nFormattedMessage('label.gateway.bundle.api.page.sort.by.date.modified.desc'),
  }, {
    uuid: 'apiModifyTs,ASC',
    text: getI18nFormattedMessage('label.gateway.bundle.api.page.sort.by.date.modified.asc'),
  }, {
    uuid: 'apiName,ASC',
    text: getI18nFormattedMessage('label.sort.by.api.name.asc'),
  }, {
    uuid: 'apiName,DESC',
    text: getI18nFormattedMessage('label.sort.by.api.name.desc'),
  },
];

export const GATEWAY_BUNDLES_API_STATES_FILTER_BY = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.gateway.bundle.api.states.all'),
  }, {
    uuid: 'Enabled',
    text: getI18nFormattedMessage('label.gateway.bundle.api.states.enabled'),
  }, {
    uuid: 'Disabled',
    text: getI18nFormattedMessage('label.gateway.bundle.api.states.disabled'),
  }, {
    uuid: 'Deprecated',
    text: getI18nFormattedMessage('label.gateway.bundle.api.states.deprecated'),
  }, {
    uuid: 'New',
    text: getI18nFormattedMessage('label.gateway.bundle.api.states.unpublished'),
  },
];

export const GATEWAY_BUNDLES_DETAILS_SUCCESS = 'GATEWAY_BUNDLES_DETAILS_SUCCESS';
export const GATEWAY_BUNDLES_DETAILS_ERROR = 'GATEWAY_BUNDLES_DETAILS_ERROR';
export const GATEWAY_BUNDLES_GET_SUCCESS = 'GATEWAY_BUNDLES_GET_SUCCESS';
export const GATEWAY_BUNDLES_GET_ERROR = 'GATEWAY_BUNDLES_GET_ERROR';
export const GATEWAY_BUNDLES_SAVE_SUCCESS = 'GATEWAY_BUNDLES_SAVE_SUCCESS';
export const GATEWAY_BUNDLES_SAVE_ERROR = 'GATEWAY_BUNDLES_SAVE_ERROR';
export const GATEWAY_BUNDLES_GET_USAGE_SUCCESS = 'GATEWAY_BUNDLES_GET_USAGE_SUCCESS';
export const GATEWAY_BUNDLES_GET_USAGE_ERROR = 'GATEWAY_BUNDLES_GET_USAGE_ERROR';

export const GATEWAY_BUNDLES_DELETE_SUCCESS = 'GATEWAY_BUNDLES_DELETE_SUCCESS';
export const GATEWAY_BUNDLES_DELETE_ERROR = 'GATEWAY_BUNDLES_DELETE_ERROR';

export const GATEWAY_BUNDLES_GET_PROXY_SUCCESS = 'GATEWAY_BUNDLES_GET_PROXY_SUCCESS';
export const GATEWAY_BUNDLES_GET_PROXY_ERROR = 'GATEWAY_BUNDLES_GET_PROXY_ERROR';
export const GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS = 'GATEWAY_BUNDLES_GET_PROXY_LIST_SUCCESS';
export const GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR = 'GATEWAY_BUNDLES_GET_PROXY_LIST_ERROR';

export const GATEWAY_BUNDLES_GET_APIS_SUCCESS = 'GATEWAY_BUNDLES_GET_APIS_SUCCESS';
export const GATEWAY_BUNDLES_GET_APIS_ERROR = 'GATEWAY_BUNDLES_GET_APIS_ERROR';

export const GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS = 'GATEWAY_BUNDLES_DEPLOY_PROXY_SUCCESS';
export const GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS = 'GATEWAY_BUNDLES_REDEPLOY_PROXY_SUCCESS';
export const GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS = 'GATEWAY_BUNDLES_UNDEPLOY_PROXY_SUCCESS';
export const GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR = 'GATEWAY_BUNDLES_DEPLOY_PROXY_ERROR';
export const GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR = 'GATEWAY_BUNDLES_UNDEPLOY_PROXY_ERROR';
export const GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR = 'GATEWAY_BUNDLES_REDEPLOY_PROXY_ERROR';
export const GATEWAY_BUNDLES_DELETE_RESET = 'GATEWAY_BUNDLES_DELETE_RESET';
export const GATEWAY_BUNDLES_ENCAPSULATED_ASSERTION = 'ENCAPSULATED_ASSERTION';

export const GATEWAY_BUNDLES_ADD_REQUEST = 'GATEWAY_BUNDLES_ADD_REQUEST';

/* Organizations */
export const ORGANIZATIONS_GET_SUCCESS = 'ORGANIZATIONS_GET_SUCCESS';
export const ORGANIZATIONS_GET_ERROR = 'ORGANIZATIONS_GET_ERROR';
export const ORGANIZATION_LIST_GET_SUCCESS = 'ORGANIZATION_LIST_GET_SUCCESS';
export const ORGANIZATION_LIST_GET_ERROR = 'ORGANIZATION_LIST_GET_ERROR';
export const ORGANIZATION_GET_REQUEST = 'ORGANIZATION_GET_REQUEST';
export const ORGANIZATION_GET_SUCCESS = 'ORGANIZATION_GET_SUCCESS';
export const ORGANIZATION_GET_ERROR = 'ORGANIZATION_GET_ERROR';
export const ACCOUNTPLANS_GET_REQUEST = 'ACCOUNTPLANS_GET_REQUEST';
export const ACCOUNTPLANS_GET_SUCCESS = 'ACCOUNTPLANS_GET_SUCCESS';
export const ACCOUNTPLANS_GET_ERROR = 'ACCOUNTPLANS_GET_ERROR';
export const APPLICATION_LIST_REQUEST = 'APPLICATION_LIST_REQUEST';
export const APPLICATION_LIST_SUCCESS = 'APPLICATION_LIST_SUCCESS';
export const APPLICATION_LIST_ERROR = 'APPLICATION_LIST_ERROR';
export const ORGANIZATION_NAME_UNIQUE_REQUEST = 'ORGANIZATION_NAME_UNIQUE_REQUEST';
export const ORGANIZATION_NAME_UNIQUE_SUCCESS = 'ORGANIZATION_NAME_UNIQUE_SUCCESS';
export const ORGANIZATION_NAME_UNIQUE_ERROR = 'ORGANIZATION_NAME_UNIQUE_ERROR';
export const ORGANIZATION_CREATE_REQUEST = 'ORGANIZATION_CREATE_REQUEST';
export const ORGANIZATION_CREATE_SUCCESS = 'ORGANIZATION_CREATE_SUCCESS';
export const ORGANIZATION_CREATE_ERROR = 'ORGANIZATION_CREATE_ERROR';
export const ORGANIZATION_UPDATE_REQUEST = 'ORGANIZATION_UPDATE_REQUEST';
export const ORGANIZATION_UPDATE_SUCCESS = 'ORGANIZATION_UPDATE_SUCCESS';
export const ORGANIZATION_UPDATE_ERROR = 'ORGANIZATION_UPDATE_ERROR';
export const ORGANIZATION_TYPE_PUBLISHER = 'PUBLISHER';
export const ORGANIZATION_TYPE_CONSUMER = 'CONSUMER';
export const USER_PROFILE_GET_REQUEST = 'USER_PROFILE_GET_REQUEST';
export const USER_PROFILE_GET_SUCCESS = 'USER_PROFILE_GET_SUCCESS';
export const USER_PROFILE_GET_ERROR = 'USER_PROFILE_GET_ERROR';
export const USER_PROFILE_UPDATE_REQUEST = 'USER_PROFILE_UPDATE_REQUEST';
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
export const USER_PROFILE_UPDATE_ERROR = 'USER_PROFILE_UPDATE_ERROR';
export const USER_ORGANIZATIONS_FILTERED_SUCCESS = 'USER_ORGANIZATIONS_FILTERED_SUCCESS';
export const USER_ORGANIZATIONS_FILTERED_ERROR = 'USER_ORGANIZATIONS_FILTERED_ERROR';
export const PUBLIC_KEY_GET_REQUEST = 'PUBLIC_KEY_GET_REQUEST';
export const PUBLIC_KEY_GET_SUCCESS = 'PUBLIC_KEY_GET_SUCCESS';
export const PUBLIC_KEY_GET_ERROR = 'PUBLIC_KEY_GET_ERROR';
export const PASSWORD_POLICY_GET_REQUEST = 'PASSWORD_POLICY_GET_REQUEST';
export const PASSWORD_POLICY_GET_SUCCESS = 'PASSWORD_POLICY_GET_SUCCESS';
export const PASSWORD_POLICY_GET_ERROR = 'PASSWORD_POLICY_GET_ERROR';
export const REQUEST_SETTINGS_GET_REQUEST = 'REQUEST_SETTINGS_GET_REQUEST';
export const REQUEST_SETTINGS_GET_SUCCESS = 'REQUEST_SETTINGS_GET_SUCCESS';
export const REQUEST_SETTINGS_GET_ERROR = 'REQUEST_SETTINGS_GET_ERROR';
export const REQUEST_SETTINGS_UPDATE_REQUEST = 'REQUEST_SETTINGS_UPDATE_REQUEST';
export const REQUEST_SETTINGS_UPDATE_SUCCESS = 'REQUEST_SETTINGS_UPDATE_SUCCESS';
export const REQUEST_SETTINGS_UPDATE_ERROR = 'REQUEST_SETTINGS_UPDATE_ERROR';
export const API_ORG_ACCESS_RATE_QUOTA_PATCH_SUCCESS = 'API_ORG_ACCESS_RATE_QUOTA_PATCH_SUCCESS';
export const API_ORG_ACCESS_RATE_QUOTA_PATCH_ERROR = 'API_ORG_ACCESS_RATE_QUOTA_PATCH_ERROR';
export const AUTH_METHOD_CERTIFICATE = 'CERTIFICATE';
export const AUTH_METHOD_SECRET = 'SECRET';
export const AUTH_METHOD_NONE = 'NONE';
// default portal auth provider UUID,
// this should be removed once the flag is added to auth provider resource
export const DEFAULT_PORTAL_AUTH_PROVIDER_UUID = '77a39e3c-4ea6-11ef-9a16-0242ac1e0003';

export const ORGANIZATION_LIST_TYPE_FILTER_BY = [
  {
    uuid: ANY,
    text: getI18nFormattedMessage('label.organization.list.page.filter.by.all.types'),
  }, {
    uuid: 'PUBLISHER',
    text: getI18nFormattedMessage('label.organization.list.page.filter.by.publisher.types'),
  }, {
    uuid: 'CONSUMER',
    text: getI18nFormattedMessage('label.organization.list.page.filter.by.consumer.types'),
  },
];

export const APPLICATION_LIST_STATUS_BY = [
  {
    uuid: ANY,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.all.status'),
  },
  {
    uuid: APPLICATION_STATUS_ENABLED,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.enabled.status'),
  },
  {
    uuid: APPLICATION_STATUS_DISABLED,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.disabled.status'),
  },
  {
    uuid: `${APPLICATION_STATUS_DELETE_PENDING_APPROVAL},${APPLICATION_STATUS_EDIT_PENDING_APPROVAL},${APPLICATION_STATUS_PENDING_APPROVAL}`,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.pending.status'),
  },
  {
    uuid: APPLICATION_STATUS_REJECTED,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.rejected.status'),
  },
  {
    uuid: APPLICATION_STATUS_INCOMPLETE,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.incomplete.status'),
  },
  {
    uuid: APPLICATION_STATUS_DELETE_FAILED,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.delete.failed.status'),
  },
];
export const API_ACCESS_STATUS_FILTER_BY = [
  {
    uuid: ANY,
    text: getI18nFormattedMessage('label.apis.filter.accesstype.all'),
  }, {
    uuid: 'PRIVATE',
    text: getI18nFormattedMessage('label.apis.filter.accesstype.private'),
  }, {
    uuid: 'PUBLIC',
    text: getI18nFormattedMessage('label.apis.filter.accesstype.public'),
  },
];

export const USER_LIST_INACTIVITY_TYPE_FILTER_BY = [
  {
    uuid: IS_LESS_THAN,
    text: getI18nFormattedMessage('label.user.list.page.filter.by.expiry.lessthan'),
  }, {
    uuid: IS_GREATER_THAN,
    text: getI18nFormattedMessage('label.user.list.page.filter.by.expiry.morethan'),
  },
];

export const APPLICATION_LIST_EXPIRY_INTERVAL_FILTER_BY = [
  {
    uuid: IS_LESS_THAN,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.expiry.lessthan'),
  }, {
    uuid: IS_GREATER_THAN,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.expiry.greaterthan'),
  },
];

export const APPLICATION_LIST_EXPIRY_TYPE_FILTER_BY = [
  {
    uuid: EXPIRY_TYPE_SECRET,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.expiry.type.secret'),
  },
  {
    uuid: EXPIRY_TYPE_CERTIFICATE,
    text: getI18nFormattedMessage('label.application.list.page.filter.by.expiry.type.certificate'),
  },
];

export const ORGANIZATION_STATUS_ENABLED = 'ENABLED';
export const ORGANIZATION_STATUS_REGISTRATION_INIT = 'REGISTRATION_INIT';
export const ORGANIZATION_STATUS_REGISTRATION_PENDING_APPROVAL = 'REGISTRATION_PENDING_APPROVAL';

export const ORGANIZATION_STATUS_LABEL = {
  [ORGANIZATION_STATUS_ENABLED]: getI18nFormattedMessage('label.organization.status.enabled'),
  [ORGANIZATION_STATUS_REGISTRATION_INIT]: getI18nFormattedMessage('label.organization.status.registration.init'),
  [ORGANIZATION_STATUS_REGISTRATION_PENDING_APPROVAL]: getI18nFormattedMessage('label.organization.status.registration.pending.approval'),
};


export const ORGANIZATION_LIST_STATUS_FILTER_BY = [
  {
    uuid: ALL,
    text: getI18nFormattedMessage('label.organization.list.page.status.by.all.states'),
  }, {
    uuid: ORGANIZATION_STATUS_ENABLED,
    text: ORGANIZATION_STATUS_LABEL[ORGANIZATION_STATUS_ENABLED],
  }, {
    uuid: ORGANIZATION_STATUS_REGISTRATION_INIT,
    text: ORGANIZATION_STATUS_LABEL[ORGANIZATION_STATUS_REGISTRATION_INIT],
  }, {
    uuid: ORGANIZATION_STATUS_REGISTRATION_PENDING_APPROVAL,
    text: ORGANIZATION_STATUS_LABEL[ORGANIZATION_STATUS_REGISTRATION_PENDING_APPROVAL],
  },
];

/** Users */
export const ROLE_PORTAL_ADMIN_UUID = '00000001-0001-0001-0001-000000000001';
export const ROLE_PORTAL_ADMIN = 'portaladministrators';
export const ROLE_API_OWNER_UUID = '00000004-0004-0004-0004-000000000004';
export const ROLE_API_OWNER = 'apiowners';
export const ROLE_ORG_ADMIN_UUID = '00000005-0005-0005-0005-000000000005';
export const ROLE_ORG_ADMIN = 'devorgadministrators';
export const ROLE_DEVELOPER_UUID = '00000006-0006-0006-0006-000000000006';
export const ROLE_DEVELOPER = 'developers';
export const ROLE_ORG_PUBLISHER_UUID = '00000009-0009-0009-0009-000000000009';
export const ROLE_ORG_PUBLISHER = 'orgpublishers';

export const ROLE_NAME_UUID_MAP = {
  [ROLE_PORTAL_ADMIN]: ROLE_PORTAL_ADMIN_UUID,
  [ROLE_API_OWNER]: ROLE_API_OWNER_UUID,
  [ROLE_ORG_ADMIN]: ROLE_ORG_ADMIN_UUID,
  [ROLE_DEVELOPER]: ROLE_DEVELOPER_UUID,
  [ROLE_ORG_PUBLISHER]: ROLE_ORG_PUBLISHER_UUID,
};

export const ROLE_UUID_NAME_MAP = {
  [ROLE_PORTAL_ADMIN_UUID]: ROLE_PORTAL_ADMIN,
  [ROLE_API_OWNER_UUID]: ROLE_API_OWNER,
  [ROLE_ORG_ADMIN_UUID]: ROLE_ORG_ADMIN,
  [ROLE_DEVELOPER_UUID]: ROLE_DEVELOPER,
  [ROLE_ORG_PUBLISHER_UUID]: ROLE_ORG_PUBLISHER,
};

export const ROLE_NAME_USER_MAP = {
  [ROLE_PORTAL_ADMIN]: "ADMIN_USER",
  [ROLE_ORG_ADMIN]: "ORG_ADMIN",
  [ROLE_API_OWNER]: "API_OWNER",
  [ROLE_DEVELOPER]: "ORG_DEV",
  [ROLE_ORG_PUBLISHER]: "ORG_PUB",
};

export const USER_ROLE_NAME_MAP = {
  ADMIN_USER: ROLE_PORTAL_ADMIN,
  ORG_ADMIN: ROLE_ORG_ADMIN,
  API_OWNER: ROLE_API_OWNER,
  ORG_DEV: ROLE_DEVELOPER,
  ORG_PUB: ROLE_ORG_PUBLISHER,
};

export const USER_LIST_ROLE = {
  [ROLE_PORTAL_ADMIN_UUID]: `label.user.role.${ROLE_PORTAL_ADMIN}`,
  [ROLE_API_OWNER_UUID]: `label.user.role.${ROLE_API_OWNER}`,
  [ROLE_ORG_ADMIN_UUID]: `label.user.role.${ROLE_ORG_ADMIN}`,
  [ROLE_ORG_PUBLISHER_UUID]: `label.user.role.${ROLE_ORG_PUBLISHER}`,
  [ROLE_DEVELOPER_UUID]: `label.user.role.${ROLE_DEVELOPER}`,
};

export const getOrgBoundRoles = (intl) => [
  {
    uuid: ROLE_ORG_ADMIN_UUID,
    name: intl.getI18nMessage(`label.user.role.${ROLE_ORG_ADMIN}`),
  },
  {
    uuid: ROLE_ORG_PUBLISHER_UUID,
    name: intl.getI18nMessage(`label.user.role.${ROLE_ORG_PUBLISHER}`),
  },
  {
    uuid: ROLE_DEVELOPER_UUID,
    name: intl.getI18nMessage(`label.user.role.${ROLE_DEVELOPER}`),
  },
]

export const USER_STATUS_ENABLED = 'ENABLED';
export const USER_STATUS_DISABLED = 'DISABLED';
export const USER_STATUS_LOCKED = 'LOCKED';
export const USER_STATUS_REGISTRATION_INIT = 'REGISTRATION_INIT';
export const USER_STATUS_REGISTRATION_PENDING_APPROVAL = 'REGISTRATION_PENDING_APPROVAL';

export const USER_STATUS_LABEL = {
  [USER_STATUS_ENABLED]: getI18nFormattedMessage('label.user.status.enabled'),
  [USER_STATUS_DISABLED]: getI18nFormattedMessage('label.user.status.disabled'),
  [USER_STATUS_LOCKED]: getI18nFormattedMessage('label.user.status.locked'),
  [USER_STATUS_REGISTRATION_INIT]: getI18nFormattedMessage('label.user.status.registration.init'),
  [USER_STATUS_REGISTRATION_PENDING_APPROVAL]: getI18nFormattedMessage('label.user.status.registration.pending.approval'),
};

export const USER_TYPE_GLOBAL = "GLOBAL_USER";
export const USER_TYPE_ORG = "ORG_USER";

export const USER_TYPE_LIST = [
  {
    'uuid': USER_TYPE_GLOBAL,
    'text': getI18nMessageFromGlobalStore('label.user.details.usertype.global'),
  },
  {
    'uuid': USER_TYPE_ORG,
    'text': getI18nMessageFromGlobalStore('label.user.details.usertype.org'),
  },
];

export const ADMIN_USER_ROLES = [
  {
    'uuid': "ADMIN_USER",
    'text': getI18nMessageFromGlobalStore('label.user.details.userrole.admin'),
  },
  {
    'uuid': "API_OWNER",
    'text': getI18nMessageFromGlobalStore('label.user.details.userrole.apiowner'),
  },
];

export const ORG_USER_ROLES = [
  {
    'uuid': "ORG_ADMIN",
    'text': getI18nMessageFromGlobalStore('label.user.details.userrole.orgadmin'),
  },
  {
    'uuid': "ORG_DEV",
    'text': getI18nMessageFromGlobalStore('label.user.details.userrole.orgdev'),
  },
];

export const USER_LIST_STATUS_FILTER_BY = [
  {
    uuid: ALL,
    text: getI18nFormattedMessage('label.user.list.page.status.by.all.statuses'),
  }, {
    uuid: USER_STATUS_ENABLED,
    text: USER_STATUS_LABEL[USER_STATUS_ENABLED],
  }, {
    uuid: USER_STATUS_DISABLED,
    text: USER_STATUS_LABEL[USER_STATUS_DISABLED],
  }, {
    uuid: USER_STATUS_LOCKED,
    text: USER_STATUS_LABEL[USER_STATUS_LOCKED],
  }, {
    uuid: USER_STATUS_REGISTRATION_INIT,
    text: USER_STATUS_LABEL[USER_STATUS_REGISTRATION_INIT],
  }, {
    uuid: USER_STATUS_REGISTRATION_PENDING_APPROVAL,
    text: USER_STATUS_LABEL[USER_STATUS_REGISTRATION_PENDING_APPROVAL],
  },
];

export const USER_LIST_SORT_BY = [
  {
    uuid: 'fullName,ASC',
    text: getI18nFormattedMessage('label.sort.by.name.asc'),
  }, {
    uuid: 'fullName,DESC',
    text: getI18nFormattedMessage('label.sort.by.name.desc'),
  }, {
    uuid: 'username,ASC',
    text: getI18nFormattedMessage('label.sort.by.username.asc'),
  }, {
    uuid: 'username,DESC',
    text: getI18nFormattedMessage('label.sort.by.username.desc'),
  }, {
    uuid: 'status,ASC',
    text: getI18nFormattedMessage('label.sort.by.status.asc'),
  }, {
    uuid: 'status,DESC',
    text: getI18nFormattedMessage('label.sort.by.status.desc'),
  }, {
    uuid: 'lastLoginTs,ASC',
    text: getI18nFormattedMessage('label.sort.by.days.inactive.desc'),
  }, {
    uuid: 'lastLoginTs,DESC',
    text: getI18nFormattedMessage('label.sort.by.days.inactive.asc'),
  },
];

export const USERS_GET_SUCCESS = 'USERS_GET_SUCCESS';
export const USERS_GET_ERROR = 'USERS_GET_ERROR';

export const USER_GET_REQUEST = 'USER_GET_REQUEST';
export const USER_GET_SUCCESS = 'USER_GET_SUCCESS';
export const USER_GET_ERROR = 'USER_GET_ERROR';

export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR';

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';

export const USER_REVOKE_ACCESS_REQUEST = 'USER_REVOKE_ACCESS_REQUEST';
export const USER_REVOKE_ACCESS_SUCCESS = 'USER_REVOKE_ACCESS_SUCCESS';
export const USER_REVOKE_ACCESS_ERROR = 'USER_REVOKE_ACCESS_ERROR';
export const USER_REVOKE_ACCESS_RESET = 'USER_REVOKE_ACCESS_RESET';

export const USER_RESEND_ACTIVATION_EMAIL_REQUEST = 'USER_RESEND_ACTIVATION_EMAIL_REQUEST';
export const USER_RESEND_ACTIVATION_EMAIL_SUCCESS = 'USER_RESEND_ACTIVATION_EMAIL_SUCCESS';
export const USER_RESEND_ACTIVATION_EMAIL_ERROR = 'USER_RESEND_ACTIVATION_EMAIL_ERROR';

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';
export const USERS_DELETE_RESET = 'USERS_DELETE_RESET';

export const USER_BULK_DELETE_REQUEST = 'USER_BULK_DELETE_REQUEST';
export const USER_BULK_DELETE_SUCCESS = 'USER_BULK_DELETE_SUCCESS';
export const USER_BULK_DELETE_ERROR = 'USER_BULK_DELETE_ERROR';

/** Proxies **/
export const PROXY_DEPLOYMENT_TYPE_AUTOMATIC = 'AUTOMATIC';
export const PROXY_DEPLOYMENT_TYPE_ON_DEMAND = 'ON_DEMAND';
export const PROXY_DEPLOYMENT_TYPE_SCRIPTED = 'MANUAL';
export const PROXY_CONNECTION_STATUS_CONNECTED = "CONNECTED";
export const PROXY_CONNECTION_STATUS_NOT_CONNECTED = "NOT_CONNECTED";
export const PROXY_CONNECTION_STATUS = [
  {
    uuid: ALL,
    text: getI18nFormattedMessage("label.proxy.list.connection.status.all"),
  },
  {
    uuid: PROXY_CONNECTION_STATUS_CONNECTED,
    text: getI18nFormattedMessage("label.proxy.list.connection.status.connected"),
  },
  {
    uuid: PROXY_CONNECTION_STATUS_NOT_CONNECTED,
    text: getI18nFormattedMessage("label.proxy.list.connection.status.not.connected"),
  },
]


export const PROXY_GET_SUCCESS = 'PROXY_GET_SUCCESS';
export const PROXY_GET_ERROR = 'PROXY_GET_ERROR';
export const PROXY_UPDATE_REQUEST = 'PROXY_UPDATE_REQUEST';
export const PROXY_UPDATE_SUCCESS = 'PROXY_UPDATE_SUCCESS';
export const PROXY_UPDATE_ERROR = 'PROXY_UPDATE_ERROR';
export const PROXY_DELETE_SUCCESS = 'PROXY_DELETE_SUCCESS';
export const PROXY_DELETE_ERROR = 'PROXY_DELETE_ERROR';
export const PROXY_DETAILS_GET_SUCCESS = 'PROXY_DETAILS_GET_SUCCESS';
export const PROXY_DETAILS_GET_ERROR = 'PROXY_DETAILS_GET_ERROR';
export const PROXY_GATEWAY_GET_REQUEST = 'PROXY_GATEWAY_GET_REQUEST';
export const PROXY_GATEWAY_GET_SUCCESS = 'PROXY_GATEWAY_GET_SUCCESS';
export const PROXY_GATEWAY_GET_ERROR = 'PROXY_GATEWAY_GET_ERROR';
export const PROXY_APIS_GET_REQUEST = 'PROXY_APIS_GET_REQUEST';
export const PROXY_APIS_GET_SUCCESS = 'PROXY_APIS_GET_SUCCESS';
export const PROXY_APIS_GET_ERROR = 'PROXY_APIS_GET_ERROR';
export const PROXY_ORGANIZATIONS_GET_SUCCESS = 'PROXY_ORGANIZATIONS_GET_SUCCESS';
export const PROXY_ORGANIZATIONS_GET_ERROR = 'PROXY_ORGANIZATIONS_GET_ERROR';
export const PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS = 'PROXY_CONFIG_UPDATE_NEW_SYNC_SUCCESS';
export const PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR = 'PROXY_CONFIG_UPDATE_NEW_SYNC_ERROR';
export const PROXY_APIS_LIST_GET_SUCCESS = 'PROXY_APIS_LIST_GET_SUCCESS';
export const PROXY_APIS_LIST_GET_ERROR = 'PROXY_APIS_LIST_GET_ERROR';
export const PROXY_APIS_KEYS_LIST_GET_SUCCESS = 'PROXY_APIS_KEYS_LIST_GET_SUCCESS';
export const PROXY_APIS_KEYS_LIST_GET_ERROR = 'PROXY_APIS_KEYS_LIST_GET_ERROR';
export const PROXY_APIS_KEYS_COUNT_GET_SUCCESS = 'PROXY_APIS_KEYS_COUNT_GET_SUCCESS';
export const PROXY_APIS_KEYS_COUNT_GET_ERROR = 'PROXY_APIS_KEYS_COUNT_GET_ERROR';
export const PROXY_API_PLANS_GET_REQUEST = 'PROXY_API_PLANS_GET_REQUEST';
export const PROXY_API_PLANS_GET_SUCCESS = 'PROXY_API_PLANS_GET_SUCCESS';
export const PROXY_API_PLANS_GET_ERROR = 'PROXY_API_PLANS_GET_ERROR';
export const PROXY_DEPLOYMENT_STATUS_GET_SUCCESS = 'PROXY_DEPLOYMENT_STATUS_GET_SUCCESS';
export const PROXY_DEPLOYMENT_STATUS_GET_ERROR = 'PROXY_DEPLOYMENT_STATUS_GET_ERROR';

export const PROXY_RATE_LIMIT_QUOTA_GET_SUCCESS = 'PROXY_RATE_LIMIT_QUOTA_GET_SUCCESS';
export const PROXY_RATE_LIMIT_QUOTA_GET_ERROR = 'PROXY_RATE_LIMIT_QUOTA_GET_ERROR';

export const PROXY_ENROLMENT_STATUS_ACTIVE = 'ACTIVE';
export const PROXY_ENROLMENT_STATUS_PENDING = 'PENDING';

export const PROXY_CONNECTED = 'PROXY_CONNECTED';
export const PROXY_DISCONNECTED = 'PROXY_DISCONNECTED';

export const BULK_DEPLOYMENT_STATUS_DONE = 'DONE';
export const BULK_DEPLOYMENT_STATUS_RUNNING = 'RUNNING';

export const PROXY_DEPLOYEMT_AUTOMATIC = 'AUTOMATIC';

export const PROXY_DETAILS_URL = '/publish/api-proxy/details/';

export const PROXY_CERTIFICATES_LIST_GET_SUCCESS = 'PROXY_CERTIFICATES_LIST_GET_SUCCESS';
export const PROXY_CERTIFICATES_LIST_GET_ERROR = 'PROXY_CERTIFICATES_LIST_GET_ERROR';
export const PROXY_ENTITIES_SUMMARY_GET_SUCCESS = 'PROXY_ENTITIES_SUMMARY_GET_SUCCESS';
export const PROXY_ENTITIES_SUMMARY_GET_ERROR = 'PROXY_ENTITIES_SUMMARY_GET_ERROR';
export const PROXY_RATE_LIMIT_DEPLOY_SUCCESS = 'PROXY_RATE_LIMIT_DEPLOY_SUCCESS';
export const PROXY_RATE_LIMIT_DEPLOY_ERROR = 'PROXY_RATE_LIMIT_DEPLOY_ERROR';

export const PROXY_ENROLLMENT_HELP_ITEMS = {
  title: 'Help',
  subItems: [{
    id: 0,
    title: '',
    descriptions: 'For more information, refer to Integrate On-Premise API Proxies > Enroll the On-Premise API Proxy Cluster step in the documentation.',
  }, {
    id: 1,
    title: '',
    descriptions: 'The enrollment URL is only valid for 24 hours. After 24 hours have elapsed, a new link must be generated by refreshing this page.',
  }, {
    id: 2,
    title: '',
    descriptions: 'Upon successful enrollment, you can view the Proxy details and manage the configurations of the proxy.',
  }],
};

export const PROXY_API_QUERY_PARAMS = {
  portalPublished: '?source=true',
  portalPending: '?source=true&status=PENDING_DEPLOYMENT&status=PENDING_UNDEPLOYMENT',
  portalDeployed: '?source=true&status=DEPLOYED',
  portalError: '?source=true&status=ERROR',
  gatewayPublished: '?source=false',
  gatewayPending: '?source=false&status=PENDING_DEPLOYMENT&status=PENDING_UNDEPLOYMENT',
  gatewayDeployed: '?source=false&status=DEPLOYED',
  gatewayError: '?source=false&status=ERROR',
  totalPublished: '',
  totalPending: '?status=PENDING_DEPLOYMENT&status=PENDING_UNDEPLOYMENT',
  totalDeployed: '?status=DEPLOYED',
  totalError: '?status=ERROR',
};

export const PROXY_KEYS_QUERY_PARAMS = {
  totalPublished: '',
  totalPending: '?status=PENDING_DEPLOYMENT&status=PENDING_UNDEPLOYMENT',
  totalDeployed: '?status=DEPLOYED',
  totalError: '?status=ERROR',
};

/** APIs */
export const APIS_GET_SUCCESS = 'APIS_GET_SUCCESS';
export const APIS_GET_ERROR = 'APIS_GET_ERROR';

export const APIS_SORT_BY = [
  {
    uuid: 'apiModifyTs,DESC',
    text: getI18nFormattedMessage('label.gateway.bundle.api.page.sort.by.date.modified.desc'),
  }, {
    uuid: 'apiModifyTs,ASC',
    text: getI18nFormattedMessage('label.gateway.bundle.api.page.sort.by.date.modified.asc'),
  }, {
    uuid: 'apiName,ASC',
    text: getI18nFormattedMessage('label.sort.by.api.name.asc'),
  }, {
    uuid: 'apiName,DESC',
    text: getI18nFormattedMessage('label.sort.by.api.name.desc'),
  },
];

export const APIS_STATES_FILTER_BY = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.apis.states.all'),
  }, {
    uuid: 'Enabled',
    text: getI18nFormattedMessage('label.apis.states.enabled'),
  }, {
    uuid: 'Disabled',
    text: getI18nFormattedMessage('label.apis.states.disabled'),
  }, {
    uuid: 'Deprecated',
    text: getI18nFormattedMessage('label.apis.states.deprecated'),
  }, {
    uuid: 'New',
    text: getI18nFormattedMessage('label.apis.states.unpublished'),
  },
];

export const PROXY_APIS_SORT_BY = [
  {
    uuid: 'lastTimeDeployed,DESC',
    text: getI18nFormattedMessage('label.apis.page.sort.by.last.deployed.desc'),
  }, {
    uuid: 'lastTimeDeployed,ASC',
    text: getI18nFormattedMessage('label.apis.page.sort.by.last.deployed.asc'),
  },
];

export const PROXY_APIS_STATES_FILTER_BY = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.apis.states.all'),
  }, {
    uuid: 'NEW',
    text: getI18nFormattedMessage('label.apis.states.unpublished'),
  }, {
    uuid: 'ENABLED',
    text: getI18nFormattedMessage('label.apis.states.enabled'),
  }, {
    uuid: 'DISABLED',
    text: getI18nFormattedMessage('label.apis.states.disabled'),
  }, {
    uuid: 'DEPRECATED',
    text: getI18nFormattedMessage('label.apis.states.deprecated'),
  }, {
    uuid: 'DELETED',
    text: getI18nFormattedMessage('label.apis.states.deleted'),
  },
];

export const APIS_PUBLISH_SOURCES_FILTER_BY = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.apis.publish.source.all'),
  }, {
    uuid: true,
    text: getI18nFormattedMessage('label.apis.publish.source.portal'),
  }, {
    uuid: false,
    text: getI18nFormattedMessage('label.apis.publish.source.gateway'),
  },
];

export const PROXY_CERTIFICATES_SORT_BY = [
  {
    uuid: 'notAfter,DESC',
    text: getI18nFormattedMessage('label.proxy.details.certificates.sort.by.last.deployed.desc'),
  }, {
    uuid: 'notAfter,ASC',
    text: getI18nFormattedMessage('label.proxy.details.certificates.sort.by.last.deployed.asc'),
  },
];

export const getApisDeploymentStatusFilterBy = (intl) => [
  {
    uuid: 'all',
    name: intl.getI18nMessage('label.deployments.state.all'),
  }, {
    uuid: 'DEPLOYED',
    name: intl.getI18nMessage('label.deployments.state.deployed'),
  }, {
    uuid: 'PENDING_DEPLOYMENT',
    name: intl.getI18nMessage('label.deployments.state.pending.deployment'),
  }, {
    uuid: 'PENDING_UNDEPLOYMENT',
    name: intl.getI18nMessage('label.deployments.state.pending.undeployment'),
  }, {
    uuid: 'ERROR',
    name: intl.getI18nMessage('label.deployments.state.error'),
  },
];

export const getKeyDeploymentStatusFilterBy = (intl) => [
  {
    uuid: 'all',
    name: intl.getI18nMessage('label..key.deployments.state.all'),
  }, {
    uuid: 'DEPLOYED',
    name: intl.getI18nMessage('label.deployments.state.deployed'),
  }, {
    uuid: 'PENDING_DEPLOYMENT',
    name: intl.getI18nMessage('label.deployments.state.pending.deployment'),
  }, {
    uuid: 'PENDING_UNDEPLOYMENT',
    name: intl.getI18nMessage('label.deployments.state.pending.undeployment'),
  }, {
    uuid: 'ERROR',
    name: intl.getI18nMessage('label.deployments.state.error'),
  },
];

export const PROXY_APIS_KEY_STATUS_FILTER_BY = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.apis.key.status.any'),
  }, {
    uuid: 'ENABLED',
    text: getI18nFormattedMessage('label.apis.states.enabled'),
  }, {
    uuid: 'DISABLED',
    text: getI18nFormattedMessage('label.apis.states.disabled'),
  }, {
    uuid: 'EXPIRED',
    text: getI18nFormattedMessage('label.application.key.state.expired'),
  }, {
    uuid: 'DELETE_FAILED',
    text: getI18nFormattedMessage('label.application.key.state.delete.failed'),
  },
];

export const CLOSE_TEXT_ID = 'label.close.button';
export const COPY_TEXT = getI18nFormattedMessage('label.copy.button');
export const COPY_CLOSE_TEXT = getI18nFormattedMessage('label.copy.close.button');
export const DIALOG_TITLE_ERROR = 'Error';

/** Applications **/
export const API_KEYS_COUNT_GET_REQUEST = 'API_KEYS_COUNT_GET_REQUEST';
export const API_KEYS_COUNT_GET_SUCCESS = 'API_KEYS_COUNT_GET_SUCCESS';
export const API_KEYS_COUNT_GET_ERROR = 'API_KEYS_COUNT_GET_ERROR';

/** Account Plans **/
export const ACCOUNT_PLANS_GET_SUCCESS = 'ACCOUNT_PLANS_GET_SUCCESS';
export const ACCOUNT_PLANS_GET_ERROR = 'ACCOUNT_PLANS_GET_ERROR';

/** API Plans **/
export const API_PLANS_GET_SUCCESS = 'API_PLANS_GET_SUCCESS';
export const API_PLANS_GET_ERROR = 'API_PLANS_GET_ERROR';

export const HTTP_STATUS_BAD_REQUEST = 400;
export const HTTP_STATUS_UNAUTHORIZED = 401;
export const HTTP_STATUS_SUCCESS = 200;

export const UNSAVED_DIALOG_TITLE = 'Unsaved Changes';
export const UNSAVED_DIALOG_DESCRIPTIONS = 'Your changes will be lost if you leave this page. Are you sure you want to continue away from this page?';
export const UNSAVED_DIALOG_CANCEL_TEXT = 'Stay';
export const UNSAVED_DIALOG_SUBMIT_TEXT = 'Continue';
export const UNSAVED_DIALOG_EXIT_TEXT = 'Exit';
export const PROCEED_TEXT = 'Proceed';
export const NEXT_TEXT = 'Next';
export const DONE_TEXT = 'Done';

export const GRID_ROWS_PER_PAGE_OPTIONS = [12, 24];
export const GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 12;
export const GRID_ROWS_PER_PAGE_DEFAULT_OPTION_24 = 24;
export const GRID_ROWS_PER_PAGE_EXTRA_OPTIONS = [12, 24, 48, 96];

export const CHANGE_MODE_REMOVE_ACCESS = 'CHANGE_MODE_REMOVE_ACCESS';
export const CHANGE_MODE_ADD_ACCESS = 'CHANGE_MODE_ADD_ACCESS';

export const VERSION_TEXT = 'Version';
export const CHANGE_ACTION_TEXT = 'Change';
export const ADD_APIPLAN_ACTION_TEXT = 'Add API Plan';

/** Eula **/

export const EULA_SORT_BY = [
  {
    uuid: 'apiModifyTs,DESC',
    text: getI18nFormattedMessage('label.sort.by.date.created.desc'),
  }, {
    uuid: 'apiModifyTs,ASC',
    text: getI18nFormattedMessage('label.sort.by.date.created.asc'),
  },
  {
    uuid: 'apiModifyTs,DESC',
    text: getI18nFormattedMessage('label.sort.by.date.updated.desc'),
  }, {
    uuid: 'apiModifyTs,ASC',
    text: getI18nFormattedMessage('label.sort.by.date.updated.asc'),
  }, {
    uuid: 'apiName,ASC',
    text: getI18nFormattedMessage('label.sort.by.name.asc'),
  }, {
    uuid: 'apiName,DESC',
    text: getI18nFormattedMessage('label.sort.by.name.desc'),
  },
];

export const EULAS_GET_LIST_SUCCESS = 'EULAS_GET_LIST_SUCCESS';
export const EULAS_GET_LIST_ERROR = 'EULAS_GET_LIST_ERROR';
export const EULAS_DETAILS_SUCCESS = 'EULAS_DETAILS_SUCCESS';
export const EULAS_DETAILS_ERROR = 'EULA_DETAILS_ERROR';
export const EULA_ADD_REQUEST = 'EULA_ADD_REQUEST';
export const EULA_SAVE_SUCCESS = 'EULA_SAVE_SUCCESS';
export const EULA_SAVE_ERROR = 'EULA_SAVE_ERROR';
export const EULA_DELETE_RESET = 'EULA_DELETE_RESET';
export const EULA_DELETE_SUCCESS = 'EULA_DELETE_SUCCESS';
export const EULA_DELETE_ERROR = 'EULA_DELETE_ERROR';
export const EULA_NAME_UNIQUE_SUCCESS = 'EULA_NAME_UNIQUE_SUCCESS';
export const EULA_NAME_UNIQUE_ERROR = 'EULA_NAME_UNIQUE_ERROR';
export const EULAS_APIS_LIST_SUCCESS = 'EULAS_APIS_LIST_SUCCESS';
export const EULAS_APIS_LIST_ERROR = 'EULA_APIS_LIST_ERROR';
export const EULAS_PRODUCTS_LIST_SUCCESS = 'EULAS_PRODUCTS_LIST_SUCCESS';
export const EULAS_PRODUCTS_LIST_ERROR = 'EULAS_PRODUCTS_LIST_ERROR'

/** Header Proxy status **/
export const HEADER_PROXY_STATUS_GET_SUCCESS = 'HEADER_PROXY_STATUS_GET_SUCCESS';
export const HEADER_PROXY_STATUS_GET_ERROR = 'HEADER_PROXY_STATUS_GET_ERROR';
export const PROXY_ERROR_DEFAULT_MESSAGE = 'Proxy status error';
export const PROXY_PORTAL_API_TYPE = 'PortalApiDeployment';
export const PROXY_KEY_TYPE = 'ApiKeyDeployment';
export const PROXY_GATEWAY_API_TYPE = 'GWPublishedApiDeployment';
export const PROXY_CERTIFICATE_EXPIRED_TYPE = 'EXPIRED';
export const PROXY_CERTIFICATE_EXPIRING_TYPE = 'EXPIRING';

/** Organizations */
export const ORG_TAG_POST_PUT_REQUEST = 'ORG_TAG_POST_PUT_REQUEST';
export const ORG_TAG_POST_PUT_SUCCESS = 'ORG_TAG_POST_PUT_SUCCESS';
export const ORG_TAG_POST_PUT_ERROR = 'ORG_TAG_POST_PUT_ERROR';
export const ORG_TAG_PUT_REQUEST = 'ORG_TAG_PUT_REQUEST';
export const ORG_TAG_PUT_SUCCESS = 'ORG_TAG_PUT_SUCCESS';
export const ORG_TAG_PUT_ERROR = 'ORG_TAG_PUT_ERROR';
export const ORG_RATE_QUOTA_GET_LIST_REQUEST = 'ORG_RATE_QUOTA_GET_LIST_REQUEST';
export const ORG_RATE_QUOTA_GET_LIST_SUCCESS = 'ORG_RATE_QUOTA_GET_LIST_SUCCESS';
export const ORG_RATE_QUOTA_GET_LIST_ERROR = 'ORG_RATE_QUOTA_GET_LIST_ERROR';
export const ORG_TAG_ADD = 'add';
export const ORG_TAG_REMOVE = 'remove';
export const ORG_PRODUCTS_LIST_GET_SUCCESS = 'ORG_PRODUCTS_LIST_GET_SUCCESS';
export const ORG_PRODUCTS_LIST_GET_ERROR = 'ORG_PRODUCTS_LIST_GET_ERROR';
export const ORG_PRODUCT_TIERS_GET_SUCCESS = 'ORG_PRODUCT_TIERS_GET_SUCCESS';
export const ORG_PRODUCT_TIERS_GET_ERROR = 'ORG_PRODUCT_TIERS_GET_ERROR';
export const ORGS_PRODUCTS_UPDATE_SUCCESS = 'ORGS_PRODUCTS_UPDATE_SUCCESS';
export const ORGS_PRODUCTS_UPDATE_ERROR = 'ORGS_PRODUCTS_UPDATE_ERROR';

/** Organization - APIAccess */
export const ORG_APIACCESS_GET_LIST_REQUEST = 'ORG_APIACCESS_GET_LIST_REQUEST';
export const ORG_APIACCESS_GET_LIST_SUCCESS = 'ORG_APIACCESS_GET_LIST_SUCCESS';
export const ORG_APIACCESS_GET_LIST_ERROR = 'ORG_APIACCESS_GET_LIST_ERROR';

/** Rate and Quota */
export const RATE_QUOTA_HELP_ITEMS = {
  title: getI18nFormattedMessage('label.rate.quota.edit.help.title'),
  descriptions: '',
  subItems: [
    {
      id: 0,
      title: '',
      descriptions: 'A limit requires 3 things:',
      list: {
        items: [
          '1 - A limit defined and assigned (varies by assignment level, see below).',
          '2 - The appropriate l7.apim.system - Rate Limit & Quota Policy Template assigned to the API during publishing (see version details per assignment level).',
          '3 - The appropriate gateway bundle deployed to the proxy where the API is to be deployed.',
        ],
      },
    },
    {
      id: 1,
      title: '',
      descriptions: 'Assignment Levels:',
      list: {
        items: [
          'API - for backend protection of your API (policy template 1.0 or higher required). No further assignment is necessary.',
          'Organization - limit per organization across all APIs (formerly known as Account Plan). When creating an Organization, assign the Rate Limit & Quota to the organization. A default limit is always assigned if no limit is explicitly defined. Note that no policy template is necessary.',
          'API per Organization - for setting limits that are applied to each API across all applications within an Organization (policy template 2.0 required). Assign this limit through the API or Organization detail pages. A default limit is always assigned if no limit is explicitly defined.',
        ],
      },
    },
    {
      id: 2,
      title: '',
      descriptions: 'Limit Options:',
      list: {
        items: [
          'Rate Limit - maximum requests per second. This type of rate is divided by the number of nodes in the cluster.',
          'Rate Spread Limit Window  - when specified, this allows a burst of requests to spread over the window size in seconds. If limit exceeds, excess requests shall be throttled.',
          'Rate Maximum Concurrency - requests cannot exceed the specified number of concurrent requests.',
          'Quota Interval - interval used for the quota.',
          'Quota - maximum number of requests per defined interval.',
        ],
      },
    },
  ],
};

export const RATE_QUOTA_HELP_ITEMS_WITH_PRODUCT = {
  title: getI18nFormattedMessage('label.rate.quota.edit.help.title'),
  descriptions: '',
  subItems: [
    {
      id: 0,
      title: '',
      descriptions: 'A limit requires 3 things:',
      list: {
        items: [
          '1 - A limit defined and assigned (varies by assignment level, see below).',
          '2 - The appropriate l7.apim.system - Rate Limit & Quota Policy Template assigned to the API during publishing (see version details per assignment level).',
          '3 - The appropriate gateway bundle deployed to the proxy where the API is to be deployed.',
        ],
      },
    },
    {
      id: 1,
      title: '',
      descriptions: 'Assignment Levels:',
      list: {
        items: [
          'API - for backend protection of your API (policy template 1.0 or higher required). No further assignment is necessary.',
          'Organization - limit per organization across all APIs (formerly known as Account Plan). When creating an Organization, assign the Rate Limit & Quota to the organization. A default limit is always assigned if no limit is explicitly defined. Note that no policy template is necessary.',
          'API per Organization - for setting limits that are applied to each API across all applications within an Organization (policy template 2.0 required). Assign this limit through the API or Organization detail pages. A default limit is always assigned if no limit is explicitly defined.',
          "Product per Application - the collective limit for all APIs assigned to a product. All keys for an application share this limit. Assignment of this limit is based the product tier. Policy template 2.0.2 or higher is required on all APIs included in the product.",
        ],
      },
    },
    {
      id: 2,
      title: '',
      descriptions: 'Limit Options:',
      list: {
        items: [
          'Rate Limit - maximum requests per second. This type of rate is divided by the number of nodes in the cluster.',
          'Rate Spread Limit Window  - when specified, this allows a burst of requests to spread over the window size in seconds. If limit exceeds, excess requests shall be throttled.',
          'Rate Maximum Concurrency - requests cannot exceed the specified number of concurrent requests.',
          'Quota Interval - interval used for the quota.',
          'Quota - maximum number of requests per defined interval.',
        ],
      },
    },
  ],
};

export const RATE_QUOTA_ASSIGNMENT_LEVEL = [
  {
    id: 'API',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.api'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.api.help'),
  },
  {
    id: 'ORGANIZATION',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.organization'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.organization.help'),
  },
  {
    id: 'API_ORGANIZATION',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.api.org'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.api.organization.help'),
  },
];

export const RATE_QUOTA_ASSIGNMENT_LEVEL_WITH_PRODUCT = [
  {
    id: 'API',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.api'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.api.help'),
  },
  {
    id: 'ORGANIZATION',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.organization'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.organization.help'),
  },
  {
    id: 'API_ORGANIZATION',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.api.org'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.api.organization.help'),
  },
  {
    id: 'PRODUCT_PER_APPLICATION',
    name: getI18nFormattedMessage('label.rate.quota.assignment.level.products.per.application'),
    description: getI18nFormattedMessage('label.rate.quota.assignment.level.products.per.application.help'),
  },
];

export const RATE_QUOTA_GET_LIST_SUCCESS = 'RATE_QUOTA_GET_LIST_SUCCESS';
export const RATE_QUOTA_GET_LIST_ERROR = 'RATE_QUOTA_GET_LIST_ERROR';
export const RATE_QUOTA_DETAILS_SUCCESS = 'RATE_QUOTA_DETAILS_SUCCESS';
export const RATE_QUOTA_DETAILS_ERROR = 'RATE_QUOTA_DETAILS_ERROR';
export const RATE_QUOTA_ADD_REQUEST = 'RATE_QUOTA_ADD_REQUEST';
export const RATE_QUOTA_SAVE_SUCCESS = 'RATE_QUOTA_SAVE_SUCCESS';
export const RATE_QUOTA_SAVE_ERROR = 'RATE_QUOTA_SAVE_ERROR';
export const RATE_QUOTA_DELETE_RESET = 'RATE_QUOTA_DELETE_RESET';
export const RATE_QUOTA_DELETE_SUCCESS = 'RATE_QUOTA_DELETE_SUCCESS';
export const RATE_QUOTA_DELETE_ERROR = 'RATE_QUOTA_DELETE_ERROR';
export const API_RATE_QUOTA_GET_LIST_SUCCESS = 'API_RATE_QUOTA_GET_LIST_SUCCESS';
export const API_RATE_QUOTA_SUCCESS = 'API_RATE_QUOTA_SUCCESS';
export const RATE_QUOTA_ORGANIZATION_LIST_GET_SUCCESS = 'RATE_QUOTA_ORGANIZATION_LIST_GET_SUCCESS';
export const RATE_QUOTA_ORGANIZATION_LIST_GET_ERROR = 'RATE_QUOTA_ORGANIZATION_LIST_GET_ERROR';
export const RATE_QUOTA_APIS_ORGANIZATION_LIST_GET_SUCCESS = 'RATE_QUOTA_APIS_ORGANIZATION_LIST_GET_SUCCESS';
export const RATE_QUOTA_APIS_ORGANIZATION_LIST_GET_ERROR = 'RATE_QUOTA_APIS_ORGANIZATION_LIST_GET_ERROR';
export const RATE_QUOTA_APIS_ORGANIZATION_DETAILS_GET_SUCCESS = 'RATE_QUOTA_APIS_ORGANIZATION_DETAILS_GET_SUCCESS';
export const RATE_QUOTA_APIS_ORGANIZATION_DETAILS_GET_ERROR = 'RATE_QUOTA_APIS_ORGANIZATION_DETAILS_GET_ERROR';

export const REQUESTS_GET_LIST_SUCCESS = 'REQUESTS_GET_LIST_SUCCESS';
export const REQUESTS_GET_LIST_ERROR = 'REQUESTS_GET_LIST_ERROR';
export const REQUESTS_GET_LIST_DETAILS_SUCCESS = 'REQUESTS_GET_LIST_DETAILS_SUCCESS';
export const REQUESTS_GET_LIST_DETAILS_ERROR = 'REQUESTS_GET_LIST_DETAILS_ERROR';
export const REQUEST_GET_DETAILS_SUCCESS = 'REQUEST_GET_DETAILS_SUCCESS';
export const REQUEST_GET_DETAILS_ERROR = 'REQUEST_GET_DETAILS_ERROR';
export const REQUESTS_GET_ORG_SUGGEST_SUCCESS = 'REQUESTS_GET_ORG_SUGGEST_SUCCESS';
export const REQUESTS_GET_ORG_SUGGEST_ERROR = 'REQUESTS_GET_ORG_SUGGEST_ERROR';
export const REQUESTS_PUT_SUBMIT_REQUEST = 'REQUESTS_PUT_SUBMIT_REQUEST';
export const REQUESTS_PUT_SUBMIT_SUCCESS = 'REQUESTS_PUT_SUBMIT_SUCCESS';
export const REQUESTS_PUT_SUBMIT_ERROR = 'REQUESTS_PUT_SUBMIT_ERROR';
export const REQUESTS_PUT_BULK_SUBMIT_REQUEST = 'REQUESTS_PUT_BULK_SUBMIT_REQUEST';
export const REQUESTS_PUT_BULK_SUBMIT_SUCCESS = 'REQUESTS_PUT_BULK_SUBMIT_SUCCESS';
export const REQUESTS_PUT_BULK_SUBMIT_ERROR = 'REQUESTS_PUT_BULK_SUBMIT_ERROR';
export const REQUEST_FILTER_CONTAINS = 'CONTAINS';
export const REQUEST_FILTER_DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN';
export const REQUEST_WITHDRAW_POST_SUCCESS = 'REQUEST_WITHDRAW_POST_SUCCESS';
export const REQUEST_WITHDRAW_POST_ERROR = 'REQUEST_WITHDRAW_POST_ERROR';
export const REQUESTS_FILTER_EMAIL_TYPE = [
  {
    uuid: REQUEST_FILTER_CONTAINS,
    text: getI18nFormattedMessage('label.request.filter.email.type.contains'),
  },
  {
    uuid: REQUEST_FILTER_DOES_NOT_CONTAIN,
    text: getI18nFormattedMessage('label.request.filter.email.type.does.not.contain'),
  },
]

export const APPLICATION_REVIEWS_PUT_REQUEST = 'APPLICATION_REVIEWS_PUT_REQUEST';
export const APPLICATION_REVIEWS_PUT_SUCCESS = 'APPLICATION_REVIEWS_PUT_SUCCESS';
export const APPLICATION_REVIEWS_PUT_ERROR = 'APPLICATION_REVIEWS_PUT_ERROR';

export const APPLICATION_REQUEST_LIST_TYPES = [
  {
    uuid: 'ALL_APPLICATION_TYPES',
    text: getI18nFormattedMessage('label.request.list.request.type.all.application'),
  },
  {
    uuid: 'APPLICATION',
    text: getI18nFormattedMessage('label.request.list.request.type.application.filter'),
  },
  {
    uuid: 'APPLICATION_DETAILS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.details'),
  },
  {
    uuid: 'APPLICATION_APIS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.apis'),
  },
  {
    uuid: 'APPLICATION_API_GROUPS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.api.groups'),
  },
  {
    uuid: 'APPLICATION_CUSTOM_FIELDS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.custom.fields'),
  },
  {
    uuid: 'APPLICATION_API_KEYS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.api.keys'),
  },
  {
    uuid: 'APPLICATION_API_PLANS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.api.plans'),
  },
  {
    uuid: 'APPLICATION_CERTIFICATES',
    text: getI18nFormattedMessage('label.request.list.request.type.application.certificates'),
  },
  {
    uuid: 'APPLICATION_PRODUCTS',
    text: getI18nFormattedMessage('label.request.list.request.type.application.products'),
  },
  {
    uuid: 'APPLICATION_OAUTH_CLIENTS',
    text: getI18nFormattedMessage('label.request.details.section.title.oauthclients'),
  },
];

export const QUOTA_INTERVAL_HOUR = 'HOUR';
export const QUOTA_INTERVAL_DAY = 'DAY';
export const QUOTA_INTERVAL_MONTH = 'MONTH';
export const DISTRIBUTED_RATE_LIMIT_INTERVAL_SECOND = 'SECOND';
export const DISTRIBUTED_RATE_LIMIT_INTERVAL_MINUTE = 'MINUTE';
export const QUOTA_ASSIGNMENT_API = 'API';
export const QUOTA_ASSIGNMENT_ORG = 'ORGANIZATION';
export const QUOTA_ASSIGNMENT_API_ORG = 'API_ORGANIZATION';
export const QUOTA_ASSIGNMENT_API_ORG_TEXT = 'API per Organization';
export const QUOTA_ASSIGNMENT_PRODUCT_PER_APPLICATION = 'PRODUCT_PER_APPLICATION';
export const QUOTA_ASSIGNMENT_PRODUCT_PER_APPLICATION_TEXT = 'Product per Application';

export const QUOTAS_INTERVAL_API = [
  {
    uuid: QUOTA_INTERVAL_HOUR,
    text: getI18nFormattedMessage('label.rate.quota.per.hourly'),
  }, {
    uuid: QUOTA_INTERVAL_DAY,
    text: getI18nFormattedMessage('label.rate.quota.per.daily'),
  },
  {
    uuid: QUOTA_INTERVAL_MONTH,
    text: getI18nFormattedMessage('label.rate.quota.per.monthly'),
  },
];

export const DISTRIBUTED_RATE_LIMIT_INTERVAL_API = [
  {
    uuid: DISTRIBUTED_RATE_LIMIT_INTERVAL_SECOND,
    text: getI18nFormattedMessage('label.rate.quota.limit.distributed.rate.limit.per.second'),
  }, {
    uuid: DISTRIBUTED_RATE_LIMIT_INTERVAL_MINUTE,
    text: getI18nFormattedMessage('label.rate.quota.limit.distributed.rate.limit.per.minute'),
  },
];

export const QUOTAS_INTERVAL_ORG = [
  {
    uuid: QUOTA_INTERVAL_HOUR,
    text: getI18nFormattedMessage('label.rate.quota.per.hourly'),
  }, {
    uuid: QUOTA_INTERVAL_DAY,
    text: getI18nFormattedMessage('label.rate.quota.per.daily'),
  },
  {
    uuid: QUOTA_INTERVAL_MONTH,
    text: getI18nFormattedMessage('label.rate.quota.per.monthly'),
  },
];

export const QUOTAS_INTERVAL_API_PLANS= [
  {
    uuid: 'DAY',
    text: 'Day',
  },
  {
    uuid: 'MONTH',
    text: 'Month',
  },
];

export const QUOTAS_INTERVAL_PRODUCT_PER_APPLICATION = [
  {
    uuid: QUOTA_INTERVAL_HOUR,
    text: getI18nFormattedMessage('label.rate.quota.per.hourly'),
  }, {
    uuid: QUOTA_INTERVAL_DAY,
    text: getI18nFormattedMessage('label.rate.quota.per.daily'),
  },
  {
    uuid: QUOTA_INTERVAL_MONTH,
    text: getI18nFormattedMessage('label.rate.quota.per.monthly'),
  },
];

export const RATE_QUOTAS_LIST_SORT_BY = [
  {
    uuid: 'name,ASC',
    text: getI18nFormattedMessage('label.sort.by.name.asc'),
  }, {
    uuid: 'name,DESC',
    text: getI18nFormattedMessage('label.sort.by.name.desc'),
  },
];

export const RATE_QUOTAS_LIST_LEVELS = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.rate.quota.all.levels'),
  }, {
    uuid: 'API',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.api'),
  }, {
    uuid: 'ORGANIZATION',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.organization'),
  },
  {
    uuid: 'API_ORGANIZATION',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.api.org'),
  },
];

export const RATE_QUOTAS_LIST_LEVELS_WITH_PRODUCTS = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.rate.quota.all.levels'),
  }, {
    uuid: 'API',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.api'),
  }, {
    uuid: 'ORGANIZATION',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.organization'),
  },
  {
    uuid: 'API_ORGANIZATION',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.api.org'),
  },
  {
    uuid: 'PRODUCT_PER_APPLICATION',
    text: getI18nFormattedMessage('label.rate.quota.assignment.level.products.per.application'),
  },
];

export const RATE_QUOTAS_LIST_LIMITS = [
  {
    uuid: 'all',
    text: getI18nFormattedMessage('label.rate.quota.all.limits'),
  },
  {
    uuid: 'rate',
    text: getI18nFormattedMessage('label.rate.quota.rate.limits'),
  },
  {
    uuid: 'distributerate',
    text: getI18nFormattedMessage('label.rate.quota.distribute.rate.limit'),
  },
  {
    uuid: 'quota',
    text: getI18nFormattedMessage('label.rate.quota.quota.limits'),
  },
];

export const CATEGORY_LIST_POSITION_FILTER_DATA = [
  {
    uuid: 'ALL_POSITIONS',
    text: getI18nFormattedMessage('label.category.list.page.filters.position.any'),
  },
  {
    uuid: 'FIXED',
    text: getI18nFormattedMessage('label.category.list.page.filters.position.fixed'),
  },
  {
    uuid: 'FLEXIBLE',
    text: getI18nFormattedMessage('label.category.list.page.filters.position.flexible'),
  },
];

export const CATEGORY_LIST_ACCESS_TYPE_FILTER_DATA = [
  {
    uuid: 'ALL_ACCESS',
    text: getI18nFormattedMessage('label.category.list.page.filters.org.restricted.all'),
  },
  {
    uuid: 'ORG',
    text: getI18nFormattedMessage('label.category.list.page.filters.org.restricted.yes'),
  },
  {
    uuid: 'GLOBAL',
    text: getI18nFormattedMessage('label.category.list.page.filters.org.restricted.no'),
  },
];

export const CATEGORY_LIST_ENFORCEMENT_FILTER_DATA = [
  {
    uuid: 'ALL_ENFORCEMENTS',
    text: getI18nFormattedMessage('label.category.list.page.filters.enforcement.any'),
  },
  {
    uuid: 'ENFORCED',
    text: getI18nFormattedMessage('label.category.list.page.filters.enforcement.enforced'),
  },
  {
    uuid: 'NOT_ENFORCED',
    text: getI18nFormattedMessage('label.category.list.page.filters.enforcement.not.enforced'),
  },
];

export const CATEGORY_LIST_EDIT_RULES_FILTER_DATA = [
  {
    uuid: 'ALL_EDIT_RULES',
    text: getI18nFormattedMessage('label.category.list.page.filters.edit.rules.any'),
  },
  {
    uuid: 'RE_ORDER',
    text: getI18nFormattedMessage('label.category.list.page.filters.edit.rules.reorder'),
  },
  {
    uuid: 'NONE',
    text: getI18nFormattedMessage('label.category.list.page.filters.edit.rules.none'),
  },
];

export const CATEGORY_LIST_USAGE_FILTER_DATA = [
  {
    uuid: 'ALL_USAGE_RULES',
    text: getI18nFormattedMessage('label.category.list.page.filters.usage.rules.all'),
  },
  {
    uuid: 'ALL',
    text: getI18nFormattedMessage('label.category.list.page.filters.usage.rules.all.required'),
  },
  {
    uuid: 'ANY',
    text: getI18nFormattedMessage('label.category.list.page.filters.usage.rules.atleast.one'),
  },
  {
    uuid: 'OPTIONAL',
    text: getI18nFormattedMessage('label.category.list.page.filters.usage.rules.optional'),
  },
];

export const CATEGORY_LIST_API_TYPE_FILTER_DATA = [
  {
    uuid: 'ALL_API_TYPES',
    text: getI18nFormattedMessage('label.category.list.page.filters.apitype.any'),
  },
  {
    uuid: 'REST',
    text: getI18nFormattedMessage('label.category.list.page.filters.apitype.rest'),
  },
  {
    uuid: 'SOAP',
    text: getI18nFormattedMessage('label.category.list.page.filters.apitype.soap'),
  },
  {
    uuid: 'ANY',
    text: getI18nFormattedMessage('label.category.list.page.filters.apitype.all'),
  },
];

export const CATEGORY_LIST_API_ACCESS_FILTER_DATA = [
  {
    uuid: 'ALL_API_ACCESS',
    text: getI18nFormattedMessage('label.category.list.page.filters.apiaccess.any'),
  },
  {
    uuid: 'PUBLIC',
    text: getI18nFormattedMessage('label.category.list.page.filters.apiaccess.public'),
  },
  {
    uuid: 'PRIVATE',
    text: getI18nFormattedMessage('label.category.list.page.filters.apiaccess.private'),
  },
  {
    uuid: 'ANY',
    text: getI18nFormattedMessage('label.category.list.page.filters.apiaccess.all'),
  },
];

export const RATE_LIMIT_QUOTA_DEFAULT_FIELD = 'l7.rateQuotaUuid';
export const RATE_LIMIT_QUOTA_LIST_FIELD = 'rateLimitQuota';
export const SYSTEM_TEMPLATE_RATE_LIMIT_QUOTA = 'l7.rq.apiOrg.enabled';

export const REQUEST_SETTINGS_STATUS_ENABLED = "ENABLED";
export const REQUEST_SETTINGS_STATUS_DISABLED = "DISABLED"

export const TIERS_GET_SUCCESS = 'TIERS_GET_SUCCESS';
export const TIERS_GET_ERROR = 'TIERS_GET_ERROR';

/** Products */
export const PRODUCTS_ADD_HELP_ITEMS = {
  title: getI18nFormattedMessage('label.product.introduction'),
  descriptions: '',
  subItems: [
    {
      id: 0,
      title: 'Products and API Access',
      descriptions: '',
      list: {
        items: [
          getI18nFormattedMessage('label.product.overview.helptext.api.item1'),
          getI18nFormattedMessage('label.product.overview.helptext.api.item2'),
          getI18nFormattedMessage('label.product.overview.helptext.api.item3'),
          getI18nFormattedMessage('label.product.overview.helptext.api.item4'),
          getI18nFormattedMessage('label.product.overview.helptext.api.item5'),
        ],
      },
    },
    {
      id: 1,
      title: 'Product Tiers and Rate Limit & Quota',
      descriptions: '',
      list: {
        items: [
          getI18nFormattedMessage('label.product.overview.helptext.tier.item1'),
          getI18nFormattedMessage('label.product.overview.helptext.tier.item2'),
          getI18nFormattedMessage('label.product.overview.helptext.tier.item3'),
          getI18nFormattedMessage('label.product.overview.helptext.tier.item4'),
          getI18nFormattedMessage('label.product.overview.helptext.tier.item5'),
          getI18nFormattedMessage('label.product.overview.helptext.tier.item6'),
          getI18nFormattedMessage('label.product.overview.helptext.tier.item7'),
        ],
      },
    },
  ],
};

export const PRODUCTS_SAVE_SUCCESS = 'PRODUCTS_SAVE_SUCCESS';
export const PRODUCTS_SAVE_ERROR = 'PRODUCTS_SAVE_ERROR';
export const PRODUCTS_DETAILS_GET_SUCCESS = 'PRODUCTS_DETAILS_GET_SUCCESS';
export const PRODUCTS_DETAILS_GET_ERROR = 'PRODUCTS_DETAILS_GET_ERROR';
export const PRODUCTS_APIS_GET_LIST_SUCCESS = 'PRODUCTS_APIS_GET_LIST_SUCCESS';
export const PRODUCTS_APIS_GET_LIST_ERROR = 'PRODUCTS_APIS_GET_LIST_ERROR';
export const PRODUCTS_APIS_ADD_REQUEST = 'PRODUCTS_APIS_ADD_REQUEST';
export const PRODUCTS_APIS_ADD_SUCCESS = 'PRODUCTS_APIS_ADD_SUCCESS';
export const PRODUCTS_APIS_UPDATE_ERROR = 'PRODUCTS_APIS_UPDATE_ERROR';
export const PRODUCTS_APIS_REMOVE_SUCCESS = 'PRODUCTS_APIS_REMOVE_SUCCESS';
export const PRODUCTS_ORGS_GET_LIST_SUCCESS = 'PRODUCTS_ORGS_GET_LIST_SUCCESS';
export const PRODUCTS_ORGS_GET_LIST_ERROR = 'PRODUCTS_ORGS_GET_LIST_ERROR';
export const PRODUCTS_ORGS_ADD_SUCCESS = 'PRODUCTS_ORGS_ADD_SUCCESS';
export const PRODUCTS_ORGS_REMOVE_SUCCESS = 'PRODUCTS_ORGS_ADD_SUCCESS';
export const PRODUCTS_ORGS_UPDATE_ERROR = 'PRODUCTS_ORGS_UPDATE_ERROR';
export const PRODUCTS_ORGS_RESET_LIST = 'PRODUCTS_ORGS_RESET_LIST';
export const TIERS_PRODUCT_GET_REQUEST = 'TIERS_PRODUCT_GET_REQUEST';
export const TIERS_PRODUCT_GET_SUCCESS = 'TIERS_PRODUCT_GET_SUCCESS';
export const TIERS_PRODUCT_GET_ERROR = 'TIERS_PRODUCT_GET_ERROR';
export const TIERS_PRODUCT_SAVE_SUCCESS = 'TIERS_PRODUCT_SAVE_SUCCESS';
export const TIERS_PRODUCT_SAVE_ERROR = 'TIERS_PRODUCT_SAVE_ERROR';
export const TIERS_PRODUCT_ASSIGNED = 'ASSIGNED';
export const TIERS_PRODUCT_NOT_ASSIGNED = 'NOT_ASSIGNED';
export const PRODUCTS_TIERS_PRODUCT_RESET_LIST = 'PRODUCTS_TIERS_PRODUCT_RESET_LIST';
export const PRODUCTS_TIERS_SUCCESS = 'PRODUCT_TIERS_SUCCESS';
export const PRODUCTS_TIERS_ERROR = 'PRODUCT_TIERS_ERROR';
export const PRODUCTS_TIERS_SAVE_SUCCESS = 'PRODUCTS_TIERS_SAVE_SUCCESS';
export const PRODUCTS_TIERS_SAVE_ERROR = 'PRODUCTS_TIERS_SAVE_ERROR';
export const PRODUCT_DELETE_SUCCESS = 'PRODUCT_DELETE_SUCCESS';
export const PRODUCT_DELETE_ERROR = 'PRODUCT_DELETE_ERROR';
export const ORG_PRODUCTS_GET_REQUEST = 'ORG_PRODUCTS_GET_REQUEST';
export const ORG_PRODUCTS_GET_SUCCESS = 'ORG_PRODUCTS_GET_SUCCESS';
export const ORG_PRODUCTS_GET_ERROR = 'ORG_PRODUCTS_GET_ERROR';
export const PRODUCTS_APPS_GET_LIST_SUCCESS = 'PRODUCTS_APPS_GET_LIST_SUCCESS';
export const PRODUCTS_APPS_GET_LIST_ERROR = 'PRODUCTS_APPS_GET_LIST_ERROR';
export const PRODUCTS_APPS_UPDATE_SUCCESS = 'PRODUCTS_APPS_UPDATE_SUCCESS';
export const PRODUCTS_APPS_UPDATE_ERROR = 'PRODUCTS_APPS_UPDATE_ERROR';
export const PRODUCTS_API_SWAGGER_SUCCESS = 'PRODUCTS_API_SWAGGER_SUCCESS';
export const PRODUCTS_API_SWAGGER_ERROR = 'PRODUCTS_API_SWAGGER_ERROR';
export const PRODUCTS_API_ASSETS_GET_SUCCESS = 'PRODUCTS_API_ASSETS_GET_SUCCESS';
export const PRODUCTS_API_ASSETS_GET_ERROR = 'PRODUCTS_API_ASSETS_GET_ERROR';
export const PRODUCTS_API_DETAILS_SUCCESS = 'PRODUCTS_API_DETAILS_SUCCESS';
export const PRODUCTS_API_DETAILS_ERROR = 'PRODUCTS_API_DETAILS_ERROR';
/** Product Visibility */
export const PRODUCT_ACCESS_TYPE_ALL = 'Access Type: All';
export const PRODUCT_ACCESS_TYPE_PUBLIC = 'Public';
export const PRODUCT_ACCESS_TYPE_PRIVATE = 'Private';
export const PRODUCT_LIST_ACCESS_TYPE_FILTER_OPTIONS = [
  {
    uuid: PRODUCT_ACCESS_TYPE_ALL,
    text: getI18nFormattedMessage('label.product.access.type.all'),
  }, {
    uuid: PRODUCT_ACCESS_TYPE_PUBLIC,
    text: getI18nFormattedMessage('label.product.access.type.public'),
  }, {
    uuid: PRODUCT_ACCESS_TYPE_PRIVATE,
    text: getI18nFormattedMessage('label.product.access.type.private'),
  },
];

export const PRODUCT_ACCESS_TYPE_DIALOG_LIST = [
  {
    id: PRODUCT_ACCESS_TYPE_PRIVATE,
    name: PRODUCT_ACCESS_TYPE_PRIVATE,
    description: getI18nFormattedMessage('label.product.details.change.access.dialog.private.description'),
  },
  {
    id: PRODUCT_ACCESS_TYPE_PUBLIC,
    name: PRODUCT_ACCESS_TYPE_PUBLIC,
    description: getI18nFormattedMessage('label.product.details.change.access.dialog.public.description'),
  },
];

export const ENTITY_GET_DOCUMENT_LIST_FETCH = 'ENTITY_GET_DOCUMENT_LIST_FETCH'
export const ENTITY_GET_DOCUMENT_LIST_SUCCESS = 'ENTITY_GET_DOCUMENT_LIST_SUCCESS';
export const ENTITY_GET_DOCUMENT_LIST_ERROR = 'ENTITY_GET_DOCUMENT_LIST_ERROR';
export const ENTITY_ADD_DOCUMENT = 'ENTITY_ADD_DOCUMENT';
export const ENTITY_GET_DOCUMENT_SUCCESS = 'ENTITY_GET_DOCUMENT_SUCCESS';
export const ENTITY_GET_DOCUMENT_ERROR = 'ENTITY_GET_DOCUMENT_ERROR';
export const ENTITY_DOCUMENT_SAVE_SUCCESS = 'ENTITY_DOCUMENT_SAVE_SUCCESS';
export const ENTITY_DOCUMENT_SAVE_ERROR = 'ENTITY_DOCUMENT_SAVE_ERROR';
export const ENTITY_DOCUMENT_DELETE_SUCCESS = 'ENTITY_DOCUMENT_DELETE_SUCCESS';
export const ENTITY_DOCUMENT_DELETE_ERROR = 'ENTITY_DOCUMENT_DELETE_ERROR';
export const ENTITY_DOCUMENT_UPDATE_TREE_SUCCESS = 'ENTITY_DOCUMENT_UPDATE_TREE_SUCCESS';
export const ENTITY_DOCUMENT_UPDATE_TREE_ERROR = 'ENTITY_DOCUMENT_UPDATE_TREE_ERROR';
export const ENTITY_DOCUMENT_RESET_NOTIFICATION = 'ENTITY_DOCUMENT_RESET_NOTIFICATION';

/* Registration Settings */
export const REGISTRATION_SETTINGS_GET_REQUEST = "REGISTRATION_SETTINGS_GET_REQUEST";
export const REGISTRATION_SETTINGS_GET_SUCCESS = "REGISTRATION_SETTINGS_GET_SUCCESS";
export const REGISTRATION_SETTINGS_GET_ERROR = "REGISTRATION_SETTINGS_GET_ERROR";
export const REGISTRATION_SETTINGS_UPDATE_REQUEST = "REGISTRATION_SETTINGS_UPDATE_REQUEST";
export const REGISTRATION_SETTINGS_UPDATE_SUCCESS = "REGISTRATION_SETTINGS_UPDATE_SUCCESS";
export const REGISTRATION_SETTINGS_UPDATE_ERROR = "REGISTRATION_SETTINGS_UPDATE_ERROR";
export const REGISTRATION_SETTINGS_STATUS_ENABLED = "ENABLED";
export const REGISTRATION_SETTINGS_STATUS_DISABLED = "DISABLED";
export const REGISTRATION_SETTINGS_LIMIT_ENABLED = true;
export const REGISTRATION_SETTINGS_LIMIT_DISABLED = false;
export const REGISTRATION_SETTINGS_TERMS_OF_USE_DEFAULT = "Terms of use text.";
export const REGISTRATION_SETTINGS_LIMIT_ID_DEFAULT = ''
export const REGISTRATION_SETTINGS_TERMS_OF_USE_MAX_LENGTH = '65535'

/** Application key settings */
export const KEY_SETTINGS_GET_REQUEST = 'KEY_SETTINGS_GET_REQUEST';
export const KEY_SETTINGS_GET_SUCCESS = 'KEY_SETTINGS_GET_SUCCESS';
export const KEY_SETTINGS_GET_ERROR = 'KEY_SETTINGS_GET_ERROR';

export const KEY_SETTINGS_UPDATE_REQUEST = 'KEY_SETTINGS_UPDATE_REQUEST';
export const KEY_SETTINGS_UPDATE_SUCCESS = 'KEY_SETTINGS_UPDATE_SUCCESS';
export const KEY_SETTINGS_UPDATE_ERROR = 'KEY_SETTINGS_UPDATE_ERROR';

export const EXECUTE_EXPIRY_JOB_REQUEST = 'EXECUTE_EXPIRY_JOB_REQUEST';
export const EXECUTE_EXPIRY_JOB_SUCCESS = 'EXECUTE_EXPIRY_JOB_SUCCESS';
export const EXECUTE_EXPIRY_JOB_ERROR = 'EXECUTE_EXPIRY_JOB_ERROR';

export const EXECUTE_EXPIRY_REPORTING_JOB_REQUEST = 'EXECUTE_EXPIRY_REPORTING_JOB_REQUEST';
export const EXECUTE_EXPIRY_REPORTING_JOB_SUCCESS = 'EXECUTE_EXPIRY_REPORTING_JOB_SUCCESS';
export const EXECUTE_EXPIRY_REPORTING_JOB_ERROR = 'EXECUTE_EXPIRY_REPORTING_JOB_ERROR';

export const FETCH_SETTINGS_CUSTOM_FIELDS_SUCCESS = 'FETCH_SETTINGS_CUSTOM_FIELDS_SUCCESS';
export const FETCH_SETTINGS_CUSTOM_FIELDS_ERROR = 'FETCH_SETTINGS_CUSTOM_FIELDS_ERROR';
export const CUSTOM_FIELDS_DELETE_REQUEST = 'CUSTOM_FIELDS_DELETE_REQUEST';
export const CUSTOM_FIELDS_DELETE_SUCCESS = 'CUSTOM_FIELDS_DELETE_SUCCESS';
export const CUSTOM_FIELDS_DELETE_ERROR = 'CUSTOM_FIELDS_DELETE_ERROR';

export const FETCH_CUSTOM_FIELDS_OPTIONS_SUCCESS = "FETCH_CUSTOM_FIELDS_OPTIONS_SUCCESS";
export const FETCH_CUSTOM_FIELDS_OPTIONS_ERROR = "FETCH_CUSTOM_FIELDS_OPTIONS_ERROR";

export const FETCH_CUSTOM_FIELDS_EDIT_SUCCESS = "FETCH_CUSTOM_FIELDS_EDIT_SUCCESS";
export const FETCH_CUSTOM_FIELDS_EDIT_ERROR = "FETCH_CUSTOM_FIELDS_EDIT_ERROR";

export const CUSTOM_FIELDS_UPDATE_REQUEST = "CUSTOM_FIELDS_UPDATE_REQUEST";
export const CUSTOM_FIELDS_UPDATE_SUCCESS = "CUSTOM_FIELDS_UPDATE_SUCCESS";
export const CUSTOM_FIELDS_UPDATE_ERROR = "CUSTOM_FIELDS_UPDATE_ERROR";

export const CUSTOM_FIELDS_NAME_UNIQUE_SUCCESS = "CUSTOM_FIELDS_NAME_UNIQUE_SUCCESS";
export const CUSTOM_FIELDS_NAME_UNIQUE_ERROR = "CUSTOM_FIELDS_NAME_UNIQUE_ERROR";

export const ADD_CUSTOM_FIELDS_REQUEST = "ADD_CUSTOM_FIELDS_REQUEST";
export const ADD_CUSTOM_FIELDS_SUCCESS = "ADD_CUSTOM_FIELDS_SUCCESS";
export const ADD_CUSTOM_FIELDS_ERROR = "ADD_CUSTOM_FIELDS_ERROR";

export const AUTH_SCHEMES_GET_LIST_REQUEST = 'AUTH_SCHEMES_GET_LIST_REQUEST';
export const AUTH_SCHEMES_GET_LIST_SUCCESS = 'AUTH_SCHEMES_GET_LIST_SUCCESS';
export const AUTH_SCHEMES_GET_LIST_ERROR = 'AUTH_SCHEMES_GET_LIST_ERROR';
export const FETCH_DISABLE_LOCAL_LOGIN_FEATURE_FLAG_SUCCESS = 'FETCH_DISABLE_LOCAL_LOGIN_FEATURE_FLAG_SUCCESS';

export const AUTH_SETTINGS_GET_LIST_SUCCESS = 'AUTH_SETTINGS_GET_LIST_SUCCESS';
export const AUTH_SETTINGS_GET_LIST_ERROR = 'AUTH_SETTINGS_GET_LIST_ERROR';
export const AUTH_SETTINGS_UPDATE_DEFAULT_SUCCESS = 'AUTH_SETTINGS_UPDATE_DEFAULT_SUCCESS';
export const AUTH_SETTINGS_UPDATE_DEFAULT_ERROR = 'AUTH_SETTINGS_UPDATE_DEFAULT_ERROR';
export const AUTH_SETTINGS_NAME_UNIQUE_SUCCESS = 'AUTH_SETTINGS_NAME_UNIQUE_SUCCESS';
export const AUTH_SETTINGS_NAME_UNIQUE_ERROR = 'AUTH_SETTINGS_NAME_UNIQUE_ERROR';
export const AUTH_SETTINGS_GET_SCHEMA_DETAILS_SUCCESS = 'AUTH_SETTINGS_GET_SCHEMA_DETAILS_SUCCESS';
export const AUTH_SETTINGS_GET_SCHEMA_DETAILS_ERROR = 'AUTH_SETTINGS_GET_SCHEMA_DETAILS_ERROR';
export const AUTH_SETTINGS_SET_LDAP_AUTH_DETAILS = 'AUTH_SETTINGS_SET_LDAP_AUTH_DETAILS';
export const AUTH_SETTINGS_SAVE_SCHEMA_SUCCESS = 'AUTH_SETTINGS_SAVE_SCHEMA_SUCCESS';
export const AUTH_SETTINGS_SAVE_SCHEMA_ERROR = 'AUTH_SETTINGS_SAVE_SCHEMA_ERROR';
export const AUTH_SETTINGS_UPDATE_SCHEMA_SUCCESS = 'AUTH_SETTINGS_UPDATE_SCHEMA_SUCCESS';
export const AUTH_SETTINGS_UPDATE_SCHEMA_ERROR = 'AUTH_SETTINGS_UPDATE_SCHEMA_ERROR';
export const AUTH_SETTINGS_DELETE_SUCCESS = 'AUTH_SETTINGS_DELETE_SUCCESS';
export const AUTH_SETTINGS_DELETE_ERROR = 'AUTH_SETTINGS_DELETE_ERROR';

export const AUTH_SETTINGS_METHOD = {
  'label.auth.type.casso': 'CASSO',
  'label.auth.type.default': 'default',
  'label.auth.type.ldap': 'LDAP',
  'label.auth.type.deprecated.saml': 'SAMLOld',
  'label.auth.type.saml': 'SAML',
  'label.auth.type.jwtpapi': 'JWT',
};

export const TEMPLATE_CATEGORY_GET_REQUEST = 'TEMPLATE_CATEGORY_GET_REQUEST';
export const TEMPLATE_CATEGORY_GET_SUCCESS = 'TEMPLATE_CATEGORY_GET_SUCCESS';
export const TEMPLATE_CATEGORY_GET_ERROR = 'TEMPLATE_CATEGORY_GET_ERROR';

export const TEMPLATE_CATEGORY_PUT_REQUEST = 'TEMPLATE_CATEGORY_PUT_REQUEST';
export const TEMPLATE_CATEGORY_PUT_SUCCESS = 'TEMPLATE_CATEGORY_PUT_SUCCESS';
export const TEMPLATE_CATEGORY_PUT_ERROR = 'TEMPLATE_CATEGORY_PUT_ERROR';

export const TEMPLATE_CATEGORY_POST_REQUEST = 'TEMPLATE_CATEGORY_POST_REQUEST';
export const TEMPLATE_CATEGORY_POST_SUCCESS = 'TEMPLATE_CATEGORY_POST_SUCCESS';
export const TEMPLATE_CATEGORY_POST_ERROR = 'TEMPLATE_CATEGORY_POST_ERROR';

export const TEMPLATE_CATEGORY_DELETE_REQUEST = 'TEMPLATE_CATEGORY_DELETE_REQUEST';
export const TEMPLATE_CATEGORY_DELETE_SUCCESS = 'TEMPLATE_CATEGORY_DELETE_SUCCESS';
export const TEMPLATE_CATEGORY_DELETE_ERROR = 'TEMPLATE_CATEGORY_DELETE_ERROR';

export const TEMPLATE_CATEGORY_TEMPLATES_GET_REQUEST = 'TEMPLATE_CATEGORY_TEMPLATES_GET_REQUEST';
export const TEMPLATE_CATEGORY_TEMPLATES_GET_SUCCESS = 'TEMPLATE_CATEGORY_TEMPLATES_GET_SUCCESS';
export const TEMPLATE_CATEGORY_TEMPLATES_GET_ERROR = 'TEMPLATE_CATEGORY_TEMPLATES_GET_ERROR';


export const TEMPLATE_CATEGORY_APIS_ACCESS_GET_REQUEST = 'TEMPLATE_CATEGORY_APIS_GET_REQUEST';
export const TEMPLATE_CATEGORY_APIS_ACCESS_GET_SUCCESS = 'TEMPLATE_CATEGORY_APIS_GET_SUCCESS';
export const TEMPLATE_CATEGORY_APIS_ACCESS_GET_ERROR = 'TEMPLATE_CATEGORY_APIS_GET_ERROR';

export const TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_REQUEST = 'TEMPLATE_CATEGORY_APIS_ORGANIZATIONS_GET_REQUEST';
export const TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_SUCCESS = 'TEMPLATE_CATEGORY_APIS_ORGANIZATIONS_GET_SUCCESS';
export const TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_ERROR = 'TEMPLATE_CATEGORY_APIS_ORGANIZATIONS_GET_ERROR';

export const TEMPLATE_CATEGORY_TEMPLATES_UPDATE_REQUEST = 'TEMPLATE_CATEGORY_TEMPLATES_UPDATE_REQUEST';
export const TEMPLATE_CATEGORY_TEMPLATES_UPDATE_SUCCESS = 'TEMPLATE_CATEGORY_TEMPLATES_UPDATE_SUCCESS';
export const TEMPLATE_CATEGORY_TEMPLATES_UPDATE_ERROR = 'TEMPLATE_CATEGORY_TEMPLATES_UPDATE_ERROR';

export const TEMPLATE_CATEGORY_GET_DETAILS_REQUEST = 'TEMPLATE_CATEGORY_GET_DETAILS_REQUEST';
export const TEMPLATE_CATEGORY_GET_DETAILS_SUCCESS = 'TEMPLATE_CATEGORY_GET_DETAILS_SUCCESS';
export const TEMPLATE_CATEGORY_GET_DETAILS_ERROR = 'TEMPLATE_CATEGORY_GET_DETAILS_ERROR';

export const TEMPLATE_CATEGORY_ORGANIZATIONS_GET_REQUEST = 'TEMPLATE_CATEGORY_ORGANIZATIONS_GET_REQUEST';
export const TEMPLATE_CATEGORY_ORGANIZATIONS_GET_SUCCESS = 'TEMPLATE_CATEGORY_ORGANIZATIONS_GET_SUCCESS';
export const TEMPLATE_CATEGORY_ORGANIZATIONS_GET_ERROR = 'TEMPLATE_CATEGORY_ORGANIZATIONS_GET_ERROR';

export const TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_REQUEST = 'TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_REQUEST';
export const TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_SUCCESS = 'TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_SUCCESS';
export const TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_ERROR = 'TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_ERROR';

export const TEMPLATES_GET_REQUEST = 'TEMPLATES_GET_REQUEST';
export const TEMPLATES_GET_SUCCESS = 'TEMPLATES_GET_SUCCESS';
export const TEMPLATES_GET_ERROR = 'TEMPLATES_GET_ERROR';

export const TEMPLATE_CATEGORY_GET_LIST_REQUEST = 'TEMPLATE_CATEGORY_GET_LIST_REQUEST';
export const TEMPLATE_CATEGORY_GET_LIST_SUCCESS = 'TEMPLATE_CATEGORY_GET_LIST_SUCCESS';
export const TEMPLATE_CATEGORY_GET_LIST_ERROR = 'TEMPLATE_CATEGORY_GET_LIST_ERROR';

export const API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_REQUEST = 'API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_REQUEST';
export const API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_SUCCESS = 'API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_SUCCESS';
export const API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_ERROR = 'API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_ERROR';

export const TEMPLATE_CATEGORY_LIST_ORDER_REQUEST = 'TEMPLATE_CATEGORY_LIST_ORDER_REQUEST';
export const TEMPLATE_CATEGORY_LIST_ORDER_SUCCESS = 'TEMPLATE_CATEGORY_LIST_ORDER_SUCCESS';
export const TEMPLATE_CATEGORY_LIST_ORDER_ERROR = 'TEMPLATE_CATEGORY_LIST_ORDER_ERROR';

export const ERROR_TITLE_TEXT = 'Unable to carry out the operation. No updates have been made. See details below.';
export const ERROR_TEXT = 'error';
export const SAVE_AND_NEXT_TEXT = 'Save & Next';

/** API settings */
export const API_SETTINGS_GET_REQUEST = 'API_SETTINGS_GET_REQUEST';
export const API_SETTINGS_GET_SUCCESS = 'API_SETTINGS_GET_SUCCESS';
export const API_SETTINGS_GET_ERROR = 'API_SETTINGS_GET_ERROR';

export const API_SETTINGS_SPEC_DEFAULT_PROXY_GET_REQUEST = 'API_SETTINGS_SPEC_DEFAULT_PROXY_GET_REQUEST';
export const API_SETTINGS_SPEC_DEFAULT_PROXY_GET_SUCCESS = 'API_SETTINGS_SPEC_DEFAULT_PROXY_GET_SUCCESS';
export const API_SETTINGS_SPEC_DEFAULT_PROXY_GET_ERROR = 'API_SETTINGS_SPEC_DEFAULT_PROXY_GET_ERROR';

export const API_SETTINGS_UPDATE_REQUEST = 'API_SETTINGS_UPDATE_REQUEST';
export const API_SETTINGS_UPDATE_SUCCESS = 'API_SETTINGS_UPDATE_SUCCESS';
export const API_SETTINGS_UPDATE_ERROR = 'API_SETTINGS_UPDATE_ERROR';

export const API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_REQUEST = 'API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_REQUEST';
export const API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_SUCCESS = 'API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_SUCCESS';
export const API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_ERROR = 'API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_ERROR';

export const API_SETTINGS_SPEC_DEFAULT_PROXY_UPDATE_REQUEST = 'API_SETTINGS_SPEC_DEFAULT_PROXY_UPDATE_REQUEST';
export const API_SETTINGS_SPEC_DEFAULT_PROXY_UPDATE_SUCCESS = 'API_SETTINGS_SPEC_DEFAULT_PROXY_UPDATE_SUCCESS';
export const API_SETTINGS_SPEC_DEFAULT_PROXY_UPDATE_ERROR = 'API_SETTINGS_SPEC_DEFAULT_PROXY_UPDATE_ERROR';

// Register
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const UPDATE_ACCOUNT_SETUP_REQUEST = 'UPDATE_ACCOUNT_SETUP_REQUEST';
export const UPDATE_ACCOUNT_SETUP_SUCCESS = 'UPDATE_ACCOUNT_SETUP_SUCCESS';
export const UPDATE_ACCOUNT_SETUP_ERROR = 'UPDATE_ACCOUNT_SETUP_ERROR';

export const ACCOUNT_SETUP_TOKEN_REQUEST = 'ACCOUNT_SETUP_TOKEN_REQUEST';
export const ACCOUNT_SETUP_TOKEN_SUCCESS = 'ACCOUNT_SETUP_TOKEN_SUCCESS';
export const ACCOUNT_SETUP_TOKEN_ERROR = 'ACCOUNT_SETUP_TOKEN_ERROR';

export const APPEARANCE_THEMES_REQUEST = 'APPEARANCE_THEMES_REQUEST';
export const APPEARANCE_THEMES_SUCCESS = 'APPEARANCE_THEMES_SUCCESS';
export const APPEARANCE_THEMES_ERROR = 'APPEARANCE_THEMES_ERROR';

export const UPDATE_APPEARANCE_THEMES_REQUEST = 'UPDATE_APPEARANCE_THEMES_REQUEST';
export const UPDATE_APPEARANCE_THEMES_SUCCESS = 'UPDATE_APPEARANCE_THEMES_SUCCESS';
export const UPDATE_APPEARANCE_THEMES_ERROR = 'UPDATE_APPEARANCE_THEMES_ERROR';

export const RESET_APPEARANCE_THEMES_REQUEST = 'RESET_APPEARANCE_THEMES_REQUEST';
export const RESET_APPEARANCE_THEMES_SUCCESS = 'RESET_APPEARANCE_THEMES_SUCCESS';
export const RESET_APPEARANCE_THEMES_ERROR = 'RESET_APPEARANCE_THEMES_ERROR';

export const EMAIL_SETTINGS_CREATE_REQUEST = 'EMAIL_SETTINGS_CREATE_REQUEST';
export const EMAIL_SETTINGS_CREATE_SUCCESS = 'EMAIL_SETTINGS_CREATE_SUCCESS';
export const EMAIL_SETTINGS_CREATE_ERROR = 'EMAIL_SETTINGS_CREATE_ERROR';

export const FETCH_EMAIL_SETTINGS_SUCCESS = 'FETCH_EMAIL_SETTINGS_SUCCESS';
export const FETCH_EMAIL_SETTINGS_REQUEST = 'FETCH_EMAIL_SETTINGS_REQUEST';
export const FETCH_EMAIL_SETTINGS_ERROR = 'FETCH_EMAIL_SETTINGS_ERROR';

export const FETCH_EMAIL_SETTINGS_CERTIFICATE_SUCCESS = 'FETCH_EMAIL_SETTINGS_CERTIFICATE_SUCCESS';
export const FETCH_EMAIL_SETTINGS_CERTIFICATE_ERROR = 'FETCH_EMAIL_SETTINGS_CERTIFICATE_ERROR';

export const CREATE_CSR_CERTIFICATE_SUCCESS = 'CREATE_CSR_CERTIFICATE_SUCCESS';
export const CREATE_CSR_CERTIFICATE_REQUEST = 'CREATE_CSR_CERTIFICATE_REQUEST';
export const CREATE_CSR_CERTIFICATE_ERROR = 'CREATE_CSR_CERTIFICATE_ERROR';

export const CLIENT_CERTIFICATE_SUCCESS = 'CLIENT_CERTIFICATE_SUCCESS';
export const CLIENT_CERTIFICATE_REQUEST = 'CLIENT_CERTIFICATE_REQUEST';
export const CLIENT_CERTIFICATE_ERROR = 'CLIENT_CERTIFICATE_ERROR';

export const TENANT_INFO_REQUEST = 'TENANT_INFO_REQUEST';
export const TENANT_INFO_SUCCESS = 'TENANT_INFO_SUCCESS';
export const TENANT_INFO_ERROR = 'TENANT_INFO_ERROR';

export const UPDATE_TENANT_INFO_REQUEST = 'UPDATE_TENANT_INFO_REQUEST';
export const UPDATE_TENANT_INFO_SUCCESS = 'UPDATE_TENANT_INFO_SUCCESS';
export const UPDATE_TENANT_INFO_ERROR = 'UPDATE_TENANT_INFO_ERROR';

export const FETCH_GOOGLE_ANALYTICS_ID = 'FETCH_GOOGLE_ANALYTICS_ID';
export const FETCH_GOOGLE_ANALYTICS_ID_SUCCESS = 'FETCH_GOOGLE_ANALYTICS_ID_SUCCESS'
export const FETCH_GOOGLE_ANALYTICS_ID_ERROR = 'FETCH_GOOGLE_ANALYTICS_ID_ERROR'

export const UPDATE_GOOGLE_ANALYTICS_ID = 'UPDATE_GOOGLE_ANALYTICS_ID';
export const UPDATE_GOOGLE_ANALYTICS_ID_SUCCESS = 'UPDATE_GOOGLE_ANALYTICS_ID_SUCCESS'
export const UPDATE_GOOGLE_ANALYTICS_ID_ERROR = 'UPDATE_GOOGLE_ANALYTICS_ID_ERROR'

export const AUDIT_LOG_REQUEST = 'AUDIT_LOG_REQUEST';
export const AUDIT_LOG_SUCCESS = 'AUDIT_LOG_SUCCESS';
export const AUDIT_LOG_ERROR = 'AUDIT_LOG_ERROR';

export const VERSION_REQUEST = 'VERSION_REQUEST';
export const VERSION_SUCCESS = 'VERSION_SUCCESS';
export const VERSION_ERROR = 'VERSION_ERROR';

export const PUBLIC_AUTH_SCHEMES_LIST_REQUEST = 'PUBLIC_AUTH_SCHEMES_LIST_REQUEST';
export const PUBLIC_AUTH_SCHEMES_LIST_SUCCESS = 'PUBLIC_AUTH_SCHEMES_LIST_SUCCESS';
export const PUBLIC_AUTH_SCHEMES_LIST_ERROR = 'PUBLIC_AUTH_SCHEMES_LIST_ERROR';

export const GET_AUTH_SCHEME_PUBLIC_KEY_REQUEST = "GET_AUTH_SCHEME_PUBLIC_KEY_REQUEST";
export const GET_AUTH_SCHEME_PUBLIC_KEY_SUCCESS = "GET_AUTH_SCHEME_PUBLIC_KEY_SUCCESS";
export const GET_AUTH_SCHEME_PUBLIC_KEY_ERROR = "GET_AUTH_SCHEME_PUBLIC_KEY_ERROR";

export const AUTHENTICATE_LOGIN_REQUEST = "AUTHENTICATE_LOGIN_REQUEST";
export const AUTHENTICATE_LOGIN_SUCCESS = "AUTHENTICATE_LOGIN_SUCCESS";
export const AUTHENTICATE_LOGIN_ERROR = "AUTHENTICATE_LOGIN_ERROR";

export const KEY_STORE_DETAILS_GET_ERROR = 'KEY_STORE_DETAILS_GET_ERROR';
export const KEY_STORE_DETAILS_GET_SUCCESS = 'KEY+STORE_DETAILS_GET_SUCCESS';
export const KEY_STORE_SAVE_SUCCESS = 'KEY_STORE_SAVE_SUCCESS';
export const KEY_STORE_SAVE_ERROR = 'KEY_STORE_SAVE_ERROR';
export const KEY_STORE_DETAILS_PROXIES_LIST_GET_SUCCESS = 'KEY_STORE_DETAILS_PROXIES_LIST_GET_SUCCESS';
export const KEY_STORE_DETAILS_PROXIES_LIST_GET_ERROR = 'KEY_STORE_DETAILS_PROXIES_LIST_GET_ERROR';
export const KEY_STORE_PROXY_UPDATE_ACCESS_REQUEST = 'KEY_STORE_PROXY_UPDATE_ACCESS_REQUEST';
export const KEY_STORE_PROXY_UPDATE_SUCCESS = 'KEY_STORE_PROXY_UPDATE_SUCCESS';
export const KEY_STORE_PROXY_UPDATE_ERROR = 'KEY_STORE_PROXY_UPDATE_ERROR';
export const KEY_STORE_LIST_GET_SUCCESS = 'KEY_STORE_LIST_GET_SUCCESS';
export const KEY_STORE_LIST_GET_ERROR = 'KEY_STORE_LIST_GET_ERROR';
export const KEY_STORE_OVERVIEW_PROXIES_LIST_GET_SUCCESS = 'KEY_STORE_OVERVIEW_PROXIES_LIST_GET_SUCCESS';
export const KEY_STORE_OVERVIEW_PROXIES_LIST_GET_ERROR = 'KEY_STORE_OVERVIEW_PROXIES_LIST_GET_ERROR';
export const KEY_STORE_TYPE_OTK = 'OTK';
export const KEY_STORE_TYPE_REMOTE_KEY_STORE = 'REMOTE_KEY_STORE';
export const KEY_STORE_DELETE_SUCCESS = 'KEY_STORE_DELETE_SUCCESS';
export const KEY_STORE_DELETE_ERROR = 'KEY_STORE_DELETE_ERROR';
export const APP_RESET_KEY_STORE = 'APP_RESET_KEY_STORE';
export const KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_SUCCESS = 'KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_SUCCESS';
export const KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_ERROR = 'KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_ERROR';
export const KEY_STORE_DETAILS_KEY_COUNTS_GET_ERROR = 'KEY_STORE_DETAILS_KEY_COUNTS_GET_ERROR';
export const KEY_STORE_DETAILS_KEY_COUNTS_GET_SUCCESS = 'KEY_STORE_DETAILS_KEY_COUNTS_GET_SUCCESS';
export const KEY_STORE_KEY_BULK_DEPLOYMENTS_SUCCESS = 'KEY_STORE_KEY_BULK_DEPLOYMENTS_SUCCESS';
export const KEY_STORE_KEY_BULK_DEPLOYMENTS_ERROR = 'KEY_STORE_KEY_BULK_DEPLOYMENTS_ERROR';
export const KEY_STORE_CONNECTED = 'CONNECTED';
export const KEY_STORE_DISCONNECTED = 'NOT_CONNECTED';
export const KEY_STORE_DEPLOYMENT_TYPE = [{
  uuid: 'AUTOMATIC',
  text: getI18nFormattedMessage('label.key.store.deployments.type.automatic'),
}, {
  uuid: 'ON_DEMAND',
  text: getI18nFormattedMessage('label.key.store.deployments.type.on.demand'),
}];

export const KEY_STORE_TYPE = [{
  uuid: KEY_STORE_TYPE_OTK,
  text: getI18nFormattedMessage('label.key.store.type.otk'),
}, {
  uuid: KEY_STORE_TYPE_REMOTE_KEY_STORE,
  text: getI18nFormattedMessage('label.key.store.type.remote.key.store'),
}];

export const KEY_STORE_DEPLOYMENT_FILTER_TYPE = [{
  uuid: 'all',
  text: getI18nFormattedMessage('label.key.store.deployments.type.all'),
},
{
  uuid: 'AUTOMATIC',
  text: getI18nFormattedMessage('label.key.store.deployments.type.automatic'),
}, {
  uuid: 'ON_DEMAND',
  text: getI18nFormattedMessage('label.key.store.deployments.type.on.demand'),
}];

export const KEY_STORE_TYPE_FILTER_TYPE = [{
    uuid: 'all',
    text: getI18nFormattedMessage('label.key.store.type.all'),
  },
  {
    uuid: KEY_STORE_TYPE_OTK,
    text: getI18nFormattedMessage('label.key.store.type.otk'),
  }, {
    uuid: KEY_STORE_TYPE_REMOTE_KEY_STORE,
    text: getI18nFormattedMessage('label.key.store.type.remote.key.store'),
  }];

export const API_GROUPS_REQUEST = 'API_GROUPS_REQUEST';
export const API_GROUPS_SUCCESS = 'API_GROUPS_SUCCESS';
export const API_GROUPS_ERROR = 'API_GROUPS_ERROR';

export const API_PLANS_REQUEST = 'API_PLANS_REQUEST';
export const API_PLANS_SUCCESS = 'API_PLANS_SUCCESS';
export const API_PLANS_ERROR = 'API_PLANS_ERROR';

export const GET_AVAILABLE_APIS_FOR_API_GROUPS_REQUEST = 'GET_AVAILABLE_APIS_FOR_API_GROUPS_REQUEST';
export const GET_AVAILABLE_APIS_FOR_API_GROUPS_SUCCESS = 'GET_AVAILABLE_APIS_FOR_API_GROUPS_SUCCESS';
export const GET_AVAILABLE_APIS_FOR_API_GROUPS_ERROR = 'GET_AVAILABLE_APIS_FOR_API_GROUPS_ERROR';

export const CREATE_API_GROUP_REQUEST = 'CREATE_API_GROUP_REQUEST';
export const CREATE_API_GROUP_SUCCESS = 'CREATE_API_GROUP_SUCCESS';
export const CREATE_API_GROUP_ERROR = 'CREATE_API_GROUP_ERROR';

export const FETCH_SINGLE_API_GROUP_REQUEST = 'FETCH_SINGLE_API_GROUP_REQUEST';
export const FETCH_SINGLE_API_GROUP_SUCCESS = 'FETCH_SINGLE_API_GROUP_SUCCESS';
export const FETCH_SINGLE_API_GROUP_ERROR = 'FETCH_SINGLE_API_GROUP_ERROR';

export const EDIT_API_GROUP_REQUEST = 'EDIT_API_GROUP_REQUEST';
export const EDIT_API_GROUP_SUCCESS = 'EDIT_API_GROUP_SUCCESS';
export const EDIT_API_GROUP_ERROR = 'EDIT_API_GROUP_ERROR';

export const DELETE_API_GROUP_REQUEST = 'DELETE_API_GROUP_REQUEST';
export const DELETE_API_GROUP_SUCCESS = 'DELETE_API_GROUP_SUCCESS';
export const DELETE_API_GROUP_ERROR = 'DELETE_API_GROUP_ERROR';

export const FETCH_API_GROUP_NAME_UNIQUE_SUCCESS = 'FETCH_API_GROUP_NAME_UNIQUE_SUCCESS';
export const FETCH_API_GROUP_NAME_UNIQUE_ERROR = 'FETCH_API_GROUP_NAME_UNIQUE_ERROR';

export const ENABLE_API_PLANS_REQUEST = 'ENABLE_API_PLANS_REQUEST';
export const ENABLE_API_PLANS_SUCCESS = 'ENABLE_API_PLANS_SUCCESS';
export const ENABLE_API_PLANS_ERROR = 'ENABLE_API_PLANS_ERROR';

export const CREATE_API_PLANS_REQUEST = 'CREATE_API_PLANS_REQUEST';
export const CREATE_API_PLANS_SUCCESS = 'CREATE_API_PLANS_SUCCESS';
export const CREATE_API_PLANS_ERROR = 'CREATE_API_PLANS_ERROR';


export const FETCH_API_PLANS_DETAILS_REQUEST = 'FETCH_API_PLANS_DETAILS_REQUEST';
export const FETCH_API_PLANS_DETAILS_SUCCESS = 'FETCH_API_PLANS_DETAILS_SUCCESS';
export const FETCH_API_PLANS_DETAILS_ERROR = 'FETCH_API_PLANS_DETAILS_ERROR';

export const UPDATE_API_PLANS_REQUEST = 'UPDATE_API_PLANS_REQUEST';
export const UPDATE_API_PLANS_SUCCESS = 'UPDATE_API_PLANS_SUCCESS';
export const UPDATE_API_PLANS_ERROR = 'UPDATE_API_PLANS_ERROR';

export const FETCH_APIS_FOR_API_PLANS_REQUEST = 'FETCH_APIS_FOR_API_PLANS_REQUEST';
export const FETCH_APIS_FOR_API_PLANS_SUCCESS = 'FETCH_APIS_FOR_API_PLANS_SUCCESS';
export const FETCH_APIS_FOR_API_PLANS_ERROR = 'FETCH_APIS_FOR_API_PLANS_ERROR';

export const UPDATE_APIS_FOR_API_PLANS_SUCCESS = 'UPDATE_APIS_FOR_API_PLANS_SUCCESS';
export const UPDATE_APIS_FOR_API_PLANS_ERROR = 'UPDATE_APIS_FOR_API_PLANS_ERROR';

export const FETCH_ORGANIZATIONS_FOR_API_PLANS_REQUEST = 'FETCH_ORGANIZATIONS_FOR_API_PLANS_REQUEST';
export const FETCH_ORGANIZATIONS_FOR_API_PLANS_SUCCESS = 'FETCH_ORGANIZATIONS_FOR_API_PLANS_SUCCESS';
export const FETCH_ORGANIZATIONS_FOR_API_PLANS_ERROR = 'FETCH_ORGANIZATIONS_FOR_API_PLANS_ERROR';

export const UPDATE_ORGANIZATIONS_FOR_API_PLANS_SUCCESS = 'UPDATE_ORGANIZATIONS_FOR_API_PLANS_SUCCESS';
export const UPDATE_ORGANIZATIONS_FOR_API_PLANS_ERROR = 'UPDATE_ORGANIZATIONS_FOR_API_PLANS_ERROR';

export const DELETE_API_PLAN_REQUEST = 'DELETE_API_PLAN_REQUEST';
export const DELETE_API_PLAN_SUCCESS = 'DELETE_API_PLAN_SUCCESS';
export const DELETE_API_PLAN_ERROR = 'DELETE_API_PLAN_ERROR';

export const UPDATE_APIS_FOR_API_GROUPS_SUCCESS = 'UPDATE_APIS_FOR_API_GROUPS_SUCCESS';
export const UPDATE_APIS_FOR_API_GROUPS_ERROR = 'UPDATE_APIS_FOR_API_GROUPS_ERROR';

export const RESET_AUTH_PROVIDERS_EDIT_STATUSES = 'RESET_AUTH_PROVIDERS_EDIT_STATUSES';

export const FETCH_AUTH_PROVIDERS_LIST_REQUEST = 'FETCH_AUTH_PROVIDERS_LIST_REQUEST';
export const FETCH_AUTH_PROVIDERS_LIST_SUCCESS = 'FETCH_AUTH_PROVIDERS_LIST_SUCCESS';
export const FETCH_AUTH_PROVIDERS_LIST_ERROR = 'FETCH_AUTH_PROVIDERS_LIST_ERROR';

export const FETCH_AUTH_PROVIDER_REQUEST = 'FETCH_AUTH_PROVIDER_REQUEST';
export const FETCH_AUTH_PROVIDER_SUCCESS = 'FETCH_AUTH_PROVIDER_SUCCESS';
export const FETCH_AUTH_PROVIDER_ERROR = 'FETCH_AUTH_PROVIDER_ERROR';

export const CREATE_AUTH_PROVIDER_REQUEST = 'CREATE_AUTH_PROVIDER_REQUEST';
export const CREATE_AUTH_PROVIDER_SUCCESS = 'CREATE_AUTH_PROVIDER_SUCCESS';
export const CREATE_AUTH_PROVIDER_ERROR = 'CREATE_AUTH_PROVIDER_ERROR';

export const UPDATE_AUTH_PROVIDER_REQUEST = 'UPDATE_AUTH_PROVIDER_REQUEST';
export const UPDATE_AUTH_PROVIDER_SUCCESS = 'UPDATE_AUTH_PROVIDER_SUCCESS';
export const UPDATE_AUTH_PROVIDER_ERROR = 'UPDATE_AUTH_PROVIDER_ERROR';

export const DELETE_AUTH_PROVIDER_REQUEST = 'DELETE_AUTH_PROVIDER_REQUEST';
export const DELETE_AUTH_PROVIDER_SUCCESS = 'DELETE_AUTH_PROVIDER_SUCCESS';
export const DELETE_AUTH_PROVIDER_ERROR = 'DELETE_AUTH_PROVIDER_ERROR';

export const KEY_STORE_STATUS= [{
  uuid: 'all',
  text: getI18nFormattedMessage('label.key.store.status.all'),
},
{
  uuid: 'CONNECTED',
  text: getI18nFormattedMessage('label.key.store.connected'),
}, {
  uuid: 'NOT_CONNECTED',
  text: getI18nFormattedMessage('label.key.store.disconnected'),
}];

export const PERMISSION_PRODUCT = 'PRODUCT';
export const PERMISSION_TIER = 'TIER';
export const PERMISSION_ORGANIZATIONS_PRODUCT = 'ORGANIZATIONS_PRODUCT';
export const PERMISSION_APIS_PRODUCT = 'APIS_PRODUCT';
export const PERMISSION_TIERS_PRODUCT = 'TIERS_PRODUCT';
export const PERMISSION_TIERS_RATE_QUOTA = 'RATE_QUOTA';
export const PERMISSION_APPLICATIONS_PRODUCT = 'APPLICATIONS_PRODUCT';
export const PERMISSION_ORGANIZATION = 'ORGANIZATION';

export const UPDATE_NEW_PASSWORD_REQUEST = 'UPDATE_NEW_PASSWORD_REQUEST';
export const UPDATE_NEW_PASSWORD_SUCCESS = 'UPDATE_NEW_PASSWORD_SUCCESS';
export const UPDATE_NEW_PASSWORD_ERROR = 'UPDATE_NEW_PASSWORD_ERROR';

export const NEW_PASSWORD_TOKEN_VALID_SUCCESS = 'NEW_PASSWORD_TOKEN_VALID_SUCCESS';
export const NEW_PASSWORD_TOKEN_VALID_ERROR = 'NEW_PASSWORD_TOKEN_VALID_ERROR';

export const UPDATE_CHANGE_PASSWORD_REQUEST = 'UPDATE_CHANGE_PASSWORD_REQUEST';
export const UPDATE_CHANGE_PASSWORD_SUCCESS = 'UPDATE_CHANGE_PASSWORD_SUCCESS';
export const UPDATE_CHANGE_PASSWORD_ERROR = 'UPDATE_CHANGE_PASSWORD_ERROR';

export const CHANGE_PASSWORD_TOKEN_VALID_SUCCESS = 'CHANGE_PASSWORD_TOKEN_VALID_SUCCESS';
export const CHANGE_PASSWORD_TOKEN_VALID_ERROR = 'CHANGE_PASSWORD_TOKEN_VALID_ERROR';
export const PERMISSION_APPLICATION = 'APPLICATION';
export const PERMISSION_PRODUCTS_APPLICATION = 'PRODUCTS_APPLICATION';
export const PERMISSION_APIS_APPLICATION_PRODUCT = 'APIS_APPLICATION_PRODUCT';
export const PERMISSION_TIERS_APPLICATION = 'TIERS_APPLICATION';
export const PERMISSION_PRODUCTS_API = 'PRODUCTS_API';

export const API_KEYS_APPLICATION = 'API_KEYS_APPLICATION';

export const FETCH_ALL_SAMPLE_CLIENT_METADATA_REQUEST = 'FETCH_ALL_SAMPLE_CLIENT_METADATA_REQUEST';
export const FETCH_ALL_SAMPLE_CLIENT_METADATA_SUCCESS = 'FETCH_ALL_SAMPLE_CLIENT_METADATA_SUCCESS';
export const FETCH_ALL_SAMPLE_CLIENT_METADATA_ERROR = 'FETCH_ALL_SAMPLE_CLIENT_METADATA_ERROR';

export const OAUTH_CLIENT_CREATE_REQUEST = 'OAUTH_CLIENT_CREATE_REQUEST';
export const OAUTH_CLIENT_CREATE_SUCCESS = 'OAUTH_CLIENT_CREATE_SUCCESS';
export const OAUTH_CLIENT_CREATE_ERROR = 'OAUTH_CLIENT_CREATE_ERROR';

export const OAUTH_CLIENT_REGISTER_REQUEST = 'OAUTH_CLIENT_REGISTER_REQUEST';
export const OAUTH_CLIENT_REGISTER_SUCCESS = 'OAUTH_CLIENT_REGISTER_SUCCESS';
export const OAUTH_CLIENT_REGISTER_ERROR = 'OAUTH_CLIENT_REGISTER_ERROR';

export const OAUTH_CLIENT_UPDATE_REQUEST = 'OAUTH_CLIENT_UPDATE_REQUEST';
export const OAUTH_CLIENT_UPDATE_SUCCESS = 'OAUTH_CLIENT_UPDATE_SUCCESS';
export const OAUTH_CLIENT_UPDATE_ERROR = 'OAUTH_CLIENT_UPDATE_ERROR';

export const OAUTH_CLIENT_DELETE_REQUEST = 'OAUTH_CLIENT_DELETE_REQUEST';
export const OAUTH_CLIENT_DELETE_SUCCESS = 'OAUTH_CLIENT_DELETE_SUCCESS';
export const OAUTH_CLIENT_DELETE_ERROR = 'OAUTH_CLIENT_DELETE_ERROR';

export const OAUTH_CLIENT_GET_ALL_REQUEST = 'OAUTH_CLIENT_GET_ALL_REQUEST';
export const OAUTH_CLIENT_GET_ALL_SUCCESS = 'OAUTH_CLIENT_GET_ALL_SUCCESS';
export const OAUTH_CLIENT_GET_ALL_ERROR = 'OAUTH_CLIENT_GET_ALL_ERROR';

export const OAUTH_CLIENT_GET_ONE_REQUEST = 'OAUTH_CLIENT_GET_ONE_REQUEST';
export const OAUTH_CLIENT_GET_ONE_SUCCESS = 'OAUTH_CLIENT_GET_ONE_SUCCESS';
export const OAUTH_CLIENT_GET_ONE_ERROR = 'OAUTH_CLIENT_GET_ONE_ERROR';
export const CLEAR_OAUTH_CLIENT_DATA = 'CLEAR_OAUTH_CLIENT_DATA';

export const CREATE_SAMPLE_CLIENT_METADATA_REQUEST = 'CREATE_SAMPLE_CLIENT_METADATA_REQUEST';
export const CREATE_SAMPLE_CLIENT_METADATA_SUCCESS = 'CREATE_SAMPLE_CLIENT_METADATA_SUCCESS';
export const CREATE_SAMPLE_CLIENT_METADATA_ERROR = 'CREATE_SAMPLE_CLIENT_METADATA_ERROR';
export const CLEAR_CLIENT_METADATA_STATUSES = 'CLEAR_CLIENT_METADATA_STATUSES';
export const RESET_AUTH_PROVIDERS_LIST_STATUS = 'RESET_AUTH_PROVIDERS_LIST_STATUS';

export const UPDATE_SAMPLE_CLIENT_METADATA_REQUEST = 'UPDATE_SAMPLE_CLIENT_METADATA_REQUEST';
export const UPDATE_SAMPLE_CLIENT_METADATA_SUCCESS = 'UPDATE_SAMPLE_CLIENT_METADATA_SUCCESS';
export const UPDATE_SAMPLE_CLIENT_METADATA_ERROR = 'UPDATE_SAMPLE_CLIENT_METADATA_ERROR';

export const DELETE_SAMPLE_CLIENT_METADATA_REQUEST = 'DELETE_SAMPLE_CLIENT_METADATA_REQUEST';
export const DELETE_SAMPLE_CLIENT_METADATA_SUCCESS = 'DELETE_SAMPLE_CLIENT_METADATA_SUCCESS';
export const DELETE_SAMPLE_CLIENT_METADATA_ERROR = 'DELETE_SAMPLE_CLIENT_METADATA_ERROR';

export const AUTH_CLIENT_DEFINITION_NAME_MAX_LENGTH = "255";
export const AUTH_CLIENT_DEFINITION_METADATA_MAX_LENGTH = "8192";
export const AUTH_CLIENT_DEFINITION_DESC_MAX_LENGTH = "2048";

export const AUTH_PROVIDER_TYPE_EXTERNAL = "EXTERNAL";
export const AUTH_PROVIDER_TYPE_PORTAL = "PORTAL";
export const AUTH_PROVIDER_TYPE_PORTAL_DCR = "PORTAL_DCR";

export const AUTH_PROVIDER_OVERVIEW_TAB_ID = 'overview';
export const AUTH_PROVIDER_CLIENT_DEF_TAB_ID = 'sample-client-definition';

export const FETCH_AUTH_PROVIDER_WELLKNOWN_REQUEST = 'FETCH_AUTH_PROVIDER_WELLKNOWN_REQUEST';
export const FETCH_AUTH_PROVIDER_WELLKNOWN_SUCCESS = 'FETCH_AUTH_PROVIDER_WELLKNOWN_SUCCESS';
export const FETCH_AUTH_PROVIDER_WELLKNOWN_ERROR = 'FETCH_AUTH_PROVIDER_WELLKNOWN_ERROR';
